<template>
    <div class="mt-3">
        <div v-if="isSettingStep1">
            <div class="mb-3 pb-3" style="border-bottom: 1px solid #949494">
                <div>
                    <h5>
                        {{
                            $t('managerForm.settingPage.editBlock', {
                                field: config?.block_name
                            })
                        }}
                    </h5>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                    >{{ $t('managerForm.settingPage.nameBlock') }} <span class="text-danger">*</span></label
                >
                <div class="col-sm-9">
                    <InputText
                        :model.sync="blockForm.block_name"
                        :config.sync="configFormInput.configFieldNameBlock"
                        @blur="handleValidateField(configFormInput.configFieldNameBlock)"
                        @change="onHandleChangeNameBlock"
                    />
                    <p v-if="config?.type == ALL_BLOCK_TYPE.BLOCK_DISPLAY_1 || config?.type == ALL_BLOCK_TYPE.BLOCK_DISPLAY_2" class="my-1">
                        {{ $t('managerForm.settingPage.noteBlockDiv') }}
                    </p>
                    <p v-else class="my-1">{{ $t('managerForm.settingPage.noteNameBlock') }}</p>
                </div>
            </div>
            <!-- 入力必須にする -->
            <div v-if="isActiveOrderRequired" class="form-group row">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.orderRequired') }} </label>
                <div class="col-sm-9">
                    <InputCheckBox
                        :model.sync="blockForm.order_required"
                        :id="`check-order_required`"
                        :value="blockForm.order_required"
                        :label="``"
                        @change="onHandleRequired"
                        :disabled="isDisabledOrderRequired"
                    />
                </div>
            </div>
            <div v-if="isActiveLabel" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                    >{{
                        [ALL_BLOCK_TYPE.BLOCK_DISPLAY_1].includes(config.type)
                            ? $t('managerForm.settingPage.label_Div_1')
                            : $t('managerForm.settingPage.label')
                    }}
                    <span class="text-danger">*</span></label
                >
                <div class="col-sm-9">
                    <Editor
                        :id="`${idPrefix}managerForm_settingPage_label`"
                        :model.sync="blockForm.label"
                        :configError.sync="configFormInput.configFieldLabelBlock"
                        :configInit="{
                            height: 300
                        }"
                        :isAutoplay="config.typeScreen === PAGE_TYPES._B[1]"
                        @change="handleValidateField(configFormInput.configFieldLabelBlock)"
                    />
                    <p class="mt-2">
                        ※デザイン設定のテーブル幅と同じ、またはそれ以上のサイズの画像をアップロードした場合、「余白」に設定されている余白分が差し引かれるため、画像は小さく表示されます。
                    </p>
                </div>
            </div>
            <!-- スクロールなし -->
            <div v-if="config?.type == ALL_BLOCK_TYPE.BLOCK_DISPLAY_1 && !isScreenComplete" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">スクロールなし</label>
                <div class="col-sm-9">
                    <InputCheckBox
                        :model.sync="blockForm.is_scroll_none"
                        :id="`check-is_scroll_none`"
                        :value="blockForm.is_scroll_none"
                        :label="``"
                    />
                </div>
            </div>
            <!-- 枠線を表示する -->
            <div v-if="config?.type == ALL_BLOCK_TYPE.BLOCK_DISPLAY_1 && !isBorderSettingTypeNone" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">枠線を表示する</label>
                <div class="col-sm-9">
                    <InputCheckBox
                        :model.sync="blockForm.is_border_display"
                        :id="`check-is_border_display`"
                        :value="blockForm.is_border_display"
                        :label="``"
                    />
                </div>
            </div>
            <div
                v-if="config?.type == ALL_BLOCK_TYPE.BLOCK_DISPLAY_1 && !isScreenComplete && !blockForm.is_scroll_none"
                class="form-group row pt-3 border-top-1-color"
            >
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">スクロールの高さ</label>
                <div class="col-sm-9">
                    <div class="d-flex">
                        <InputText class="mr-2" :model.sync="blockForm.custom_height" :config.sync="configFormInput.configFieldCustomHeight" />
                        <span class="mt-2">px</span>
                    </div>
                </div>
            </div>
            <!-- <div v-if="isActiveSourceParam" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                    >{{ $t('managerForm.settingPage.sourceParam') }} <span class="text-danger">*</span></label
                >
                <div class="col-sm-9">
                    <div class="d-flex flex-wrap mb-3" style="gap: 12px">
                        <div v-for="(sourceParamItem, idx) in OPTION_SOURCE_PARAMS" :key="idx">
                            <InputRadio
                                class="mr-4"
                                :model.sync="blockForm.block_parameter.source_param"
                                :name="`sourceParamItem`"
                                :id="`sourceParamItem-${sourceParamItem.id}`"
                                :value="sourceParamItem.id"
                                :label="sourceParamItem.value"
                            />
                        </div>
                    </div>
                </div>
            </div> -->
            <div v-if="isActiveParamName" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                    >{{ $t('managerForm.settingPage.paramName') }} <span class="text-danger">*</span></label
                >
                <div class="col-sm-9">
                    <InputText
                        :model.sync="blockForm.block_parameter.param_name"
                        :config.sync="configFormInput.configFieldParamName"
                        @blur="handleValidateField(configFormInput.configFieldParamName, 'validateParamName')"
                    />
                </div>
            </div>
            <div v-if="isActiveParamURL" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                    >{{ $t('managerForm.settingPage.errorRedirectDestination') }}
                    <p>{{ $t('managerForm.settingPage.paramURL') }}</p></label
                >
                <div class="col-sm-9">
                    <InputText
                        :model.sync="blockForm.block_parameter.error_redirect_url"
                        :config.sync="configFormInput.configFieldParamUrl"
                        @blur="handleValidateField(configFormInput.configFieldParamUrl)"
                    />
                </div>
            </div>
            <div v-if="isActiveMatchingCondition" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.matchingCondition') }} </label>
                <div class="col-sm-9">
                    <div v-for="(matchingConditionItem, idx) in LIST_MATCHING_CONDITION" :key="idx">
                        <InputCheckBox
                            class="mb-2"
                            :model.sync="blockForm.block_keyword_box.matching_condition"
                            :id="`matchingCondition-${idx}`"
                            :value="matchingConditionItem.id"
                            :label="matchingConditionItem.value"
                        />
                    </div>
                </div>
            </div>
            <div v-if="isActiveFieldMaskDisplay" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.inputFieldMaskDisplay') }} </label>
                <div class="col-sm-9">
                    <div class="d-flex flex-wrap mb-3" style="gap: 12px">
                        <div v-for="(fieldMaskDisplayItem, idx) in OPTION_YES_NO" :key="idx">
                            <InputRadio
                                class="mr-4"
                                :model.sync="blockForm.block_keyword_box.field_mask_display"
                                :name="`fieldMaskDisplayItem`"
                                :id="`fieldMaskDisplayItem-${fieldMaskDisplayItem.id}`"
                                :value="fieldMaskDisplayItem.id"
                                :label="fieldMaskDisplayItem.value"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <!-- キーワード -->
            <div v-if="isActiveKeywordUpload" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                    >{{ $t('managerForm.settingPage.keywordUpload') }} <span class="text-danger ml-2">*</span>
                </label>
                <div class="col-sm-9">
                    <div class="mb-4">
                        <UploadFileCommon
                            @dataFile="handleFileKeywordUpload"
                            :id="`keywordUpload`"
                            :typeUpload="`readFile`"
                            :config="configKeywordUploadFile"
                        />
                        <p class="mb-0 text-left">
                            {{ `※アップロード可能なファイル形式：${onHandleShowNoteFileRead()}` }}
                        </p>
                    </div>
                    <div>
                        <TextareaComponent
                            :model.sync="blockForm.block_keyword_box.keyword_characters"
                            :rows="`5`"
                            :config.sync="configFormInput.configFieldKeywordUpload"
                            @blur="handleValidateField(configFormInput.configFieldKeywordUpload, 'vKeywordUpload')"
                        >
                            <div v-if="configFormInput.configFieldKeywordUpload.error" class="d-block invalid-feedback">
                                <span>
                                    {{ configFormInput.configFieldKeywordUpload.errorCustomMess }}
                                </span>
                            </div>
                        </TextareaComponent>
                    </div>
                </div>
            </div>
            <div v-if="isActiveKeywordUpload" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.duplicateInput') }} </label>
                <div class="col-sm-9">
                    <div class="d-flex flex-wrap" style="gap: 12px">
                        <div v-for="(duplicateItem, idx) in OPTION_YES_NO" :key="idx">
                            <InputRadio
                                class="mr-4"
                                :model.sync="blockForm.block_keyword_box.duplicate_input"
                                :name="`duplicateInputKeyword`"
                                :id="`duplicateInputKeyword-${duplicateItem.id}`"
                                :value="duplicateItem.id"
                                :label="duplicateItem.value"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="isActivePhonePlaceholder" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.placeholderCommon') }} </label>
                <div class="col-sm-9">
                    <div class="d-flex">
                        <InputText
                            :model.sync="blockForm.block_phone.placeholder_1"
                            :config.sync="configFormInput.configFieldPhonePlaceholder_1"
                            @blur="handleValidateField(configFormInput.configFieldPhonePlaceholder_1)"
                        />
                        <span class="mt-2 mx-2">-</span>
                        <InputText
                            :model.sync="blockForm.block_phone.placeholder_2"
                            :config.sync="configFormInput.configFieldPhonePlaceholder_2"
                            @blur="handleValidateField(configFormInput.configFieldPhonePlaceholder_2)"
                        />
                        <span class="mt-2 mx-2">-</span>
                        <InputText
                            :model.sync="blockForm.block_phone.placeholder_3"
                            :config.sync="configFormInput.configFieldPhonePlaceholder_3"
                            @blur="handleValidateField(configFormInput.configFieldPhonePlaceholder_3)"
                        />
                    </div>
                </div>
            </div>
            <div v-if="isActiveDiv2Label">
                <div class="form-group row pt-3 border-top-1-color">
                    <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                        >{{ $t('managerForm.settingPage.label1Div_2') }} <span class="text-danger">*</span></label
                    >
                    <div class="col-sm-9">
                        <Editor
                            :id="`${idPrefix}managerForm_settingPage_label1Div_2`"
                            :model.sync="blockForm.block_div_2.label_q"
                            :configError.sync="configFormInput.configFieldLabel_Q_Block1"
                            :configInit="{
                                height: 300
                            }"
                            :isAutoplay="config.typeScreen === PAGE_TYPES._B[1]"
                            @change="handleValidateField(configFormInput.configFieldLabel_Q_Block1)"
                        />
                    </div>
                </div>
                <div class="form-group row pt-3 border-top-1-color">
                    <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                        >{{ $t('managerForm.settingPage.label2Div_2') }} <span class="text-danger">*</span></label
                    >
                    <div class="col-sm-9">
                        <Editor
                            :id="`${idPrefix}managerForm_settingPage_label2Div_2`"
                            :model.sync="blockForm.block_div_2.label_a"
                            :configError.sync="configFormInput.configFieldLabel_A_Block2"
                            :configInit="{
                                height: 300
                            }"
                            :isAutoplay="config.typeScreen === PAGE_TYPES._B[1]"
                            @change="handleValidateField(configFormInput.configFieldLabel_A_Block2)"
                        />
                    </div>
                </div>
            </div>

            <div v-if="isActiveFormatYear" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                    >{{ $t('managerForm.settingPage.inputFormat(year)') }} <span class="text-danger">*</span></label
                >
                <div class="col-sm-9">
                    <div class="d-flex flex-wrap mb-3" style="gap: 12px">
                        <div v-for="(itemDateYear, idx) in OPTION_FORMAT_DATE" :key="idx">
                            <InputRadio
                                class="mr-4"
                                :model.sync="blockForm.block_date.format_year.type"
                                :name="`itemDateYear`"
                                :id="`itemDateYear-${itemDateYear.id}`"
                                :value="itemDateYear.id"
                                :label="itemDateYear.value"
                                @change="handleChangeTypeYear(blockForm.block_date.format_year.type, 'change')"
                            />
                        </div>
                    </div>
                    <div class="pt-3 border-top-1-color">
                        <div v-if="blockForm.block_date?.format_year?.type == 2">
                            <div class="d-flex flex-wrap mb-3" style="gap: 12px">
                                <div v-for="(itemTypeCalendar, idx) in OPTION_CALENDAR_WEST_TIME" :key="idx">
                                    <InputRadio
                                        class="mr-4"
                                        :model.sync="blockForm.block_date.format_year.type_calendar"
                                        :name="`itemTypeCalendar`"
                                        :id="`itemTypeCalendar-${itemTypeCalendar.id}`"
                                        :value="itemTypeCalendar.id"
                                        :label="itemTypeCalendar.value"
                                        @change="onHandleChangeTypeCanlendar"
                                    />
                                </div>
                            </div>
                            <div class="d-flex">
                                <div class="col-sm-6">
                                    <!-- 下限(西暦) -->
                                    <div class="form-group row">
                                        <label class="col-sm-2 text-nowrap" style="min-width: 90px"
                                            >{{ $t('managerForm.settingPage.lowerLimit') }}
                                        </label>
                                        <div class="col-sm-9">
                                            <InputText
                                                :model.sync="blockForm.block_date.format_year.lower_limit"
                                                :config.sync="configFormInput.configFieldLowerLimit"
                                                @blur="handleValidateField(configFormInput.configFieldLowerLimit, 'compareYear')"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <!-- 上限(西暦) -->
                                    <div class="form-group row">
                                        <label class="col-sm-2 text-nowrap" style="min-width: 90px"
                                            >{{ $t('managerForm.settingPage.upperLimit') }}
                                        </label>
                                        <div class="col-sm-9">
                                            <InputText
                                                :model.sync="blockForm.block_date.format_year.upper_limit"
                                                :config.sync="configFormInput.configFieldUpperLimit"
                                                @blur="handleValidateField(configFormInput.configFieldUpperLimit, 'compareYear')"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="form-group row">
                            <label class="col-sm-2 text-nowrap" style="min-width: 160px"
                                >{{ $t('managerForm.settingPage.placeholderCommon') }}
                            </label>
                            <div class="col-sm-6">
                                <InputText
                                    :model.sync="blockForm.block_date.format_year.placeholder"
                                    :config.sync="configFormInput.configFieldPlaceholderYear"
                                    @blur="handleValidateField(configFormInput.configFieldPlaceholderYear)"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="isActiveFormatMonthDay" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                    >{{ $t('managerForm.settingPage.inputFormat(month/day)') }} <span class="text-danger">*</span></label
                >
                <div class="col-sm-9">
                    <div class="d-flex flex-wrap mb-3" style="gap: 12px">
                        <div v-for="(itemDateMonth_Day, idx) in OPTION_FORMAT_DATE" :key="idx">
                            <InputRadio
                                class="mr-4"
                                :model.sync="blockForm.block_date.format_month_day.type"
                                :name="`itemDateMonth_Day`"
                                :id="`itemDateMonth_Day-${itemDateMonth_Day.id}`"
                                :value="itemDateMonth_Day.id"
                                :label="itemDateMonth_Day.value"
                                :disabled="true"
                                @change="handleChangeTypeMonthDay"
                            />
                        </div>
                    </div>
                    <div v-if="blockForm.block_date?.format_month_day?.type == 1" class="pt-3 border-top-1-color">
                        <div class="form-group row">
                            <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                                >{{ $t('managerForm.settingPage.placeholderCommon') }}
                            </label>
                            <div class="col-sm-9">
                                <div class="d-flex" style="gap: 18px">
                                    <div class="d-flex">
                                        <InputText
                                            :model.sync="blockForm.block_date.format_month_day.placeholder_month"
                                            :config.sync="configFormInput.configFieldPlaceholderMonth"
                                            @blur="handleValidateField(configFormInput.configFieldPlaceholderMonth)"
                                        />
                                        <span class="mt-2 ml-1">月</span>
                                    </div>

                                    <div class="d-flex">
                                        <InputText
                                            :model.sync="blockForm.block_date.format_month_day.placeholder_day"
                                            :config.sync="configFormInput.configFieldPlaceholderDay"
                                            @blur="handleValidateField(configFormInput.configFieldPlaceholderDay)"
                                        />
                                        <span class="mt-2 ml-1">日</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 最大ファイルサイズ  -->
            <div v-if="isActiveMaximumFileSize" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                    >{{ $t('managerForm.settingPage.maximumFileSize') }} <span class="text-danger">*</span></label
                >
                <div class="col-sm-9">
                    <div class="d-flex">
                        <InputText
                            :model.sync="blockForm.block_upload_file.maximum_file_size"
                            :config.sync="configFormInput.configFieldMaximumFileSize"
                            @blur="handleValidateField(configFormInput.configFieldMaximumFileSize)"
                        />
                        <span class="mt-2 ml-1">MB</span>
                    </div>
                    <p class="mb-0 mt-1">{{ $t('managerForm.settingPage.noteSetSizeFile') }}</p>
                </div>
            </div>

            <div v-if="isActiveAllowedExtensions" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.allowedExtensions') }} </label>
                <div class="col-sm-9">
                    <InputText
                        class="mb-2"
                        :model.sync="blockForm.block_upload_file.allowed_extensions"
                        :config.sync="configFormInput.configFieldAllowedExtensions"
                        @blur="handleValidateField(configFormInput.configFieldAllowedExtensions, 'charactorExtensions')"
                    />

                    <p class="mb-0">
                        ※アップロード可能なファイル形式（下記から選択） <br />&nbsp;●画像：jpeg, jpg, png, heic, gif, bmp <br />&nbsp;●動画：mp4, mov,
                        wmv <br />&nbsp;●文書・資料 ：pdf, ppt, pptx, xls, xlsx, doc, docx
                        <br />※アップロードを許可するファイルの拡張子を、カンマ区切りで複数設定できます。
                    </p>
                </div>
            </div>
            <!-- 入力形式 -->
            <div v-if="isActiveDefineIncludesInput" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.inputFormat') }} </label>
                <div class="col-sm-9">
                    <div class="d-flex flex-wrap mb-2" style="gap: 12px">
                        <div v-for="(formatInput, idx) in listOptionText" :key="idx">
                            <InputRadio
                                class="mr-4"
                                :model.sync="blockForm.input_format"
                                :name="`inputFormat`"
                                :id="`inputFormat-${formatInput.id}`"
                                :value="formatInput"
                                :label="formatInput.value"
                                @change="onHandleChangeInputFormat"
                            />
                        </div>
                    </div>
                    <span v-if="![ALL_BLOCK_TYPE.BLOCK_FULL_NAME].includes(config?.type)">{{
                        $t('managerForm.settingPage.noteMaxCharactersInput')
                    }}</span>
                </div>
            </div>

            <!-- 年齢条件 -->
            <div v-if="blockForm.input_format?.type_input === 'number'" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">年齢条件</label>
                <div class="col-sm-9">
                    <div class="form-group row mb-0">
                        <div class="col-sm-3">
                            <Multiselect
                                style="max-width: 200px"
                                :id="`ageConditionOperator`"
                                :value.sync="blockForm.block_input.age_condition.operator"
                                :options="OPTION_AGE_CONDITION"
                                :config="{ trackBy: 'id', label: 'value', error: false, isRemove: true, searchable: false, placeholder: '選択' }"
                            />
                        </div>
                        <div class="col-sm-5">
                            <InputText
                                :model.sync="blockForm.block_input.age_condition.value"
                                :config.sync="configFormInput.configFieldAgeConditionValue"
                                @blur="handleValidateField(configFormInput.configFieldAgeConditionValue)"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="isActiveIncludesOfInput" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.inputCheck') }} </label>
                <div class="col-sm-9">
                    <div v-if="!typeFormatInput.includes(blockForm.input_format?.value)" class="form-group row">
                        <!-- 文字数チェック -->
                        <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.characterCountCheck') }} </label>
                        <div class="col-sm-9">
                            <div class="form-group row">
                                <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                                    >{{ $t('managerForm.settingPage.minimumNumber') }}
                                </label>
                                <div class="col-sm-6">
                                    <InputText
                                        :model.sync="blockForm.block_input.minimum_number"
                                        :config.sync="configFormInput.configFieldMinimumNumber"
                                        @blur="handleValidateField(configFormInput.configFieldMinimumNumber, 'numberMinMax')"
                                    />
                                </div>
                            </div>
                            <!-- 最大有効文字数 -->
                            <div class="form-group row">
                                <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                                    >{{ $t('managerForm.settingPage.maximumNumber') }}
                                </label>
                                <div class="col-sm-6">
                                    <InputText
                                        :model.sync="blockForm.block_input.maximum_number"
                                        :config.sync="configFormInput.configFieldMaximumNumber"
                                        @blur="handleValidateField(configFormInput.configFieldMaximumNumber, 'numberMinMax')"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 回答有効値の範囲 -->
                    <template
                        v-if="
                            !blockForm.block_input.is_bank_code && !blockForm.block_input.is_store_number && !blockForm.block_input.is_account_number
                        "
                    >
                        <div v-if="isTypeValueNumerical || isNumericValueIncludingDecimalPoint" class="form-group row">
                            <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                                >{{ $t('managerForm.settingPage.rangeOfValidAnswerValue') }}
                            </label>
                            <div class="col-sm-9">
                                <div class="d-flex">
                                    <div class="col-sm-5">
                                        <InputText
                                            class="mb-2"
                                            :model.sync="blockForm.block_input.from_range"
                                            :config.sync="configFormInput.configFieldFromRange"
                                            @blur="handleValidateField(configFormInput.configFieldFromRange, 'fromRange')"
                                        />
                                        <div v-if="configFormInput.configFieldFromRange.error" class="d-block invalid-feedback">
                                            <span v-if="!isNumericValueIncludingDecimalPoint">
                                                {{
                                                    `${configFormInput.configFieldFromRange.maxlength - 1}桁以下でかつ${
                                                        configFormInput.configFieldFromRange.min
                                                    }から${configFormInput.configFieldFromRange.max}の整数を入力してください。`
                                                }}
                                            </span>
                                            <span v-else>
                                                {{
                                                    `整数部${configFormInput.configFieldFromRange.integer}桁、小数部${configFormInput.configFieldFromRange.decimal}桁までの数値を入力してください。`
                                                }}
                                            </span>
                                        </div>
                                    </div>
                                    <p class="mb-0 pt-2 mx-2">～</p>
                                    <div class="col-sm-5">
                                        <InputText
                                            class="mb-2"
                                            :model.sync="blockForm.block_input.to_range"
                                            :config.sync="configFormInput.configFieldToRange"
                                            @blur="handleValidateField(configFormInput.configFieldToRange, 'toRange')"
                                        />
                                        <div v-if="configFormInput.configFieldToRange.error" class="d-block invalid-feedback">
                                            <div v-if="!isNumericValueIncludingDecimalPoint">
                                                <span v-if="configFormInput.configFieldToRange.errorCompare">
                                                    {{ configFormInput.configFieldToRange.errorCompare }}
                                                </span>
                                                <span v-else>
                                                    {{
                                                        `${configFormInput.configFieldToRange.maxlength - 1}桁以下でかつ${
                                                            configFormInput.configFieldToRange.min
                                                        }から${configFormInput.configFieldToRange.max}の整数を入力してください。`
                                                    }}
                                                </span>
                                            </div>
                                            <div v-else>
                                                <span v-if="configFormInput.configFieldToRange.errorCompare">
                                                    {{ configFormInput.configFieldToRange.errorCompare }}
                                                </span>
                                                <span v-else>
                                                    {{
                                                        `整数部${configFormInput.configFieldToRange.integer}桁、小数部${configFormInput.configFieldToRange.decimal}桁までの数値を入力してください。`
                                                    }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <!-- 小数点以下の回答有効桁数 -->
                    <div v-if="isNumericValueIncludingDecimalPoint" class="form-group row">
                        <label class="col-sm-4 text-nowrap" style="min-width: 190px"
                            >{{ $t('managerForm.settingPage.numberValidDigitsAnswerAfterDecimalPoint') }}
                        </label>
                        <div class="col-sm-6">
                            <InputText
                                :model.sync="blockForm.block_input.number_after_decimal_point"
                                :config.sync="configFormInput.configFieldNumberAfterDecimalPoint"
                                @blur="handleValidateField(configFormInput.configFieldNumberAfterDecimalPoint, 'validDigitsAnswerAfterDecimalPoint')"
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.duplicateInput') }} </label>
                        <div class="col-sm-9">
                            <div class="d-flex flex-wrap" style="gap: 12px">
                                <div v-for="(duplicateItem, idx) in OPTION_YES_NO" :key="idx">
                                    <InputRadio
                                        class="mr-4"
                                        :model.sync="blockForm.block_input.duplicate_input"
                                        :name="`duplicateInput`"
                                        :id="`duplicateInput-${duplicateItem.id}`"
                                        :value="duplicateItem.id"
                                        :label="duplicateItem.value"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="isActivePlaceholderInput" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.placeholderCommon') }} </label>
                <div class="col-sm-6">
                    <InputText
                        :model.sync="blockForm.placeholder"
                        :config.sync="configFormInput.configFieldInputPlaceholder"
                        @blur="handleValidateField(configFormInput.configFieldInputPlaceholder)"
                    />
                </div>
            </div>
            <div v-if="isActivePlaceholderPostcode" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.placeholderCommon') }} </label>
                <div class="col-sm-9">
                    <div class="d-flex">
                        <InputText
                            :model.sync="blockForm.block_post_code.placeholder_1"
                            :config.sync="configFormInput.configFieldPostcodePlaceholder1"
                            @blur="handleValidateField(configFormInput.configFieldPostcodePlaceholder1)"
                        />
                        <span class="mt-2 mx-1">-</span>
                        <InputText
                            :model.sync="blockForm.block_post_code.placeholder_2"
                            :config.sync="configFormInput.configFieldPostcodePlaceholder2"
                            @blur="handleValidateField(configFormInput.configFieldPostcodePlaceholder2)"
                        />
                    </div>
                </div>
            </div>
            <div v-if="isActiveFeatureSearchAddress" class="form-group row pt-3 border-top-1-color">
                <!-- 住所検索機能 -->
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.featureSearchAddress') }} </label>
                <div class="col-sm-9">
                    <div class="d-flex flex-wrap mb-3" style="gap: 12px">
                        <div v-for="(fsearchAdd, idx) in OPTION_YES_NO" :key="idx">
                            <InputRadio
                                class="mr-4"
                                :model.sync="blockForm.block_post_code.feature_search_address"
                                :name="`featureSearchAddress`"
                                :id="`featureSearchAddress-${fsearchAdd.id}`"
                                :value="fsearchAdd.id"
                                :label="fsearchAdd.value"
                                @change="handleChangeFeatureSearchAddress(blockForm.block_post_code)"
                            />
                        </div>
                    </div>
                    <div v-if="blockForm.block_post_code.feature_search_address == 1">
                        <!-- 都道府県差込ブロック -->
                        <div class="form-group row">
                            <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                                >{{ $t('managerForm.settingPage.prefectureInsertionBlock') }}
                            </label>
                            <div class="col-sm-9">
                                <Multiselect
                                    style="max-width: 200px"
                                    :id="`prefectureInsertionBlock`"
                                    :value.sync="blockForm.block_post_code.prefecture_insertion"
                                    :options="LIST_BLOCK_SEARCH_ADDRESS"
                                    @open="handleOpenMultiselect(1)"
                                    :config="{ trackBy: 'id', label: 'block_name', error: false, isRemove: true, searchable: false }"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                                >{{ $t('managerForm.settingPage.cityInsertionBlock') }}
                            </label>
                            <div class="col-sm-9">
                                <Multiselect
                                    style="max-width: 200px"
                                    :id="`cityInsertionBlock`"
                                    :value.sync="blockForm.block_post_code.city_insertion"
                                    :options="LIST_BLOCK_SEARCH_ADDRESS"
                                    @open="handleOpenMultiselect(2)"
                                    :config="{ trackBy: 'id', label: 'block_name', error: false, isRemove: true, searchable: false }"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                                >{{ $t('managerForm.settingPage.townAreaNameInsertionBlock') }}
                            </label>
                            <div class="col-sm-9">
                                <Multiselect
                                    style="max-width: 200px"
                                    :id="`townAreaNameInsertionBlock`"
                                    :value.sync="blockForm.block_post_code.town_area_name_insertion"
                                    :options="LIST_BLOCK_SEARCH_ADDRESS"
                                    @open="handleOpenMultiselect(3)"
                                    :config="{ trackBy: 'id', label: 'block_name', error: false, isRemove: true, searchable: false }"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="isActivePlaceholderFullname" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.placeholderCommon') }} </label>
                <div class="col-sm-9">
                    <div class="d-flex">
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap mt-2" style="min-width: 50px">{{ $t('managerForm.settingPage.firstName') }} </label>
                            <div class="col-sm-9">
                                <InputText
                                    :model.sync="blockForm.block_full_name.placeholder_first_name"
                                    :config.sync="configFormInput.configFieldInputFirstNamePlaceholder"
                                    @blur="handleValidateField(configFormInput.configFieldInputFirstNamePlaceholder)"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap mt-2" style="min-width: 50px">{{ $t('managerForm.settingPage.lastName') }} </label>
                            <div class="col-sm-9">
                                <InputText
                                    :model.sync="blockForm.block_full_name.placeholder_last_name"
                                    :config.sync="configFormInput.configFieldInputLastNamePlaceholder"
                                    @blur="handleValidateField(configFormInput.configFieldInputLastNamePlaceholder)"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="isActiveSizeTextarea" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.inputFieldSize') }} </label>
                <div class="col-sm-9">
                    <div class="d-flex">
                        <!-- 横幅 -->
                        <div class="form-group row w-100">
                            <label class="col-sm-1 text-nowrap">{{ $t('managerForm.settingPage.rowsTextarea') }} </label>
                            <div class="col-sm-10">
                                <InputText
                                    :model.sync="blockForm.block_text_area.cols"
                                    :config.sync="configFormInput.configFieldColumnsTextarea"
                                    @blur="handleValidateField(configFormInput.configFieldColumnsTextarea)"
                                />
                            </div>
                        </div>
                        <div class="form-group row w-100">
                            <label class="col-sm-1 text-nowrap">{{ $t('managerForm.settingPage.colsTextarea') }} </label>
                            <div class="col-sm-10">
                                <InputText
                                    :model.sync="blockForm.block_text_area.rows"
                                    :config.sync="configFormInput.configFieldRowTextarea"
                                    @blur="handleValidateField(configFormInput.configFieldRowTextarea)"
                                />
                            </div>
                        </div>
                    </div>

                    <span>{{ $t('managerForm.settingPage.noteSizeArea') }}</span>
                </div>
            </div>
            <div v-if="isActiveFieldSize" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.inputFieldSize') }} </label>
                <div class="col-sm-6">
                    <InputText
                        class="mb-2"
                        :model.sync="blockForm.input_field_size"
                        :config.sync="configFormInput.configFieldInputFieldSize"
                        @blur="handleValidateField(configFormInput.configFieldInputFieldSize)"
                    />
                    <span>{{ $t('managerForm.settingPage.noteInputFieldSize') }}</span>
                </div>
            </div>
            <ActionOptionSelectCommon
                v-if="actionSelectCommon"
                :typeBlock="config?.type"
                :formBlock.sync="blockForm"
                :configFormInput="configFormInput"
                :SUBMITED="sttSubmited"
                class="pt-3 border-top-1-color"
            />
            <div v-if="isActiveOptionOther" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.optionOther') }} </label>
                <div class="col-sm-9">
                    <div v-if="[ALL_BLOCK_TYPE.BLOCK_RADIO, ALL_BLOCK_TYPE.BLOCK_CHECKBOX].includes(config?.type)" class="form-group row">
                        <label class="col-sm-2 text-nowrap">{{ $t('managerForm.settingPage.others') }} </label>
                        <div class="col-sm-9">
                            <!-- 使用する -->
                            <InputCheckBox
                                class="mb-2"
                                :model.sync="blockForm.setting_others.other_use"
                                :id="`check-use`"
                                :value="blockForm.setting_others.other_use"
                                :label="$t('managerForm.settingPage.use')"
                                @change="onHandleOtherUserCheckbox"
                            />
                            <div class="form-group">
                                <label class="col-sm-2 text-nowrap pl-0" style="min-width: 190px"
                                    >{{ $t('managerForm.settingPage.labelOther') }}
                                </label>
                                <div class="col-sm-9 pl-0">
                                    <InputText
                                        :model.sync="blockForm.setting_others.label_other"
                                        :config.sync="configFormInput.configFieldLabelOther"
                                        :disabled="!blockForm.setting_others.other_use"
                                        @blur="handleValidateField(configFormInput.configFieldLabelOther)"
                                    />
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-9 pl-0" style="min-width: fit-content">
                                    <div class="d-flex" style="gap: 20px">
                                        <InputCheckBox
                                            :model.sync="blockForm.setting_others.value_other_required"
                                            :id="`check-value_other_required`"
                                            :value="blockForm.setting_others.value_other_required"
                                            :label="`${$t('managerForm.settingPage.orderRequired')}`"
                                            :disabled="!blockForm.setting_others.other_use"
                                        />
                                        <div class="form-group row">
                                            <label class="col-sm-1 text-nowrap" style="min-width: 20px"
                                                >{{ $t('managerForm.settingPage.widthOther') }}
                                            </label>
                                            <div class="col-sm-9">
                                                <InputText
                                                    :model.sync="blockForm.setting_others.width_other"
                                                    :config.sync="configFormInput.configFieldWidthOther"
                                                    :disabled="!blockForm.setting_others.other_use"
                                                    @blur="handleValidateField(configFormInput.configFieldWidthOther)"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <span>{{ $t('managerForm.settingPage.noteWidthOther') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="isVisibledUncheck" class="form-group row">
                        <label class="col-sm-2 text-nowrap"
                            >{{
                                config.type == ALL_BLOCK_TYPE.BLOCK_CHECKBOX
                                    ? $t('managerForm.settingPage.uncheckCheckbox')
                                    : $t('managerForm.settingPage.uncheck')
                            }}
                        </label>
                        <div class="col-sm-9">
                            <!-- 使用する -->
                            <InputCheckBox
                                class="mb-2"
                                :model.sync="blockForm.setting_others.uncheck_use"
                                :id="`check-uncheck_use`"
                                :value="blockForm.setting_others.uncheck_use"
                                :label="`${$t('managerForm.settingPage.use')}`"
                                @change="onHandleUncheckUse"
                            />
                            <p class="my-3">
                                {{
                                    config.type == ALL_BLOCK_TYPE.BLOCK_CHECKBOX
                                        ? $t('managerForm.settingPage.noteUncheckCheckbox')
                                        : $t('managerForm.settingPage.noteUncheck')
                                }}
                            </p>
                            <div class="form-group row">
                                <label class="col-sm-1 text-nowrap">{{ $t('managerForm.settingPage.labelOther') }} </label>
                                <div class="col-sm-9">
                                    <InputText
                                        :model.sync="blockForm.setting_others.label_uncheck"
                                        :config.sync="configFormInput.configFieldLabelUncheck"
                                        :disabled="!blockForm.setting_others.uncheck_use"
                                        @blur="handleValidateField(configFormInput.configFieldLabelUncheck)"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="isActiveRemainingNumber" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.remainingNumber') }} </label>
                <div class="col-sm-9">
                    <div class="d-flex flex-wrap mb-4" style="gap: 12px">
                        <div v-for="(remainingItem, idx) in CONFIRMATION_PAGE_DISPLAY" :key="idx">
                            <InputRadio
                                class="mr-4"
                                :model.sync="blockForm.block_remaining_number.remaining_number"
                                :name="`remainingNumber`"
                                :id="`remainingNumber-${remainingItem.id}`"
                                :value="remainingItem.id"
                                :label="remainingItem.name"
                                @change="handleChangeRemainingItem"
                            />
                        </div>
                    </div>
                    <div v-if="blockForm.block_remaining_number?.remaining_number == 1" class="form-group row">
                        <label class="col-sm-2 text-nowrap">{{ $t('managerForm.settingPage.displayContent') }} </label>
                        <div class="col-sm-9">
                            <div class="d-flex flex-wrap mb-4" style="gap: 12px">
                                <div v-for="(displayContentItem, idx) in DISPLAY_CONTENT_BLOCK_REMAINING" :key="idx">
                                    <InputRadio
                                        v-if="displayContentItem.id == 1"
                                        class="mr-4"
                                        :model.sync="blockForm.block_remaining_number.display_content"
                                        :name="`displayContent`"
                                        :id="`displayContent-${displayContentItem.id}`"
                                        :value="displayContentItem.id"
                                        :label="displayContentItem.name"
                                        @change="handleChangeDisplayContentItem"
                                    />
                                </div>
                            </div>
                            <div v-if="blockForm.block_remaining_number?.display_content == 1" class="d-flex">
                                <div class="form-group row">
                                    <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                                        >{{ $t('managerForm.settingPage.remainingText') }}
                                    </label>
                                    <div class="col-sm-6">
                                        <InputText
                                            :model.sync="blockForm.block_remaining_number.remaining_text"
                                            :config.sync="configFormInput.configFieldRemainingText"
                                            @blur="handleValidateField(configFormInput.configFieldRemainingText)"
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                                        >{{ $t('managerForm.settingPage.textAfterremainingnumber') }}
                                    </label>
                                    <div class="col-sm-6">
                                        <InputText
                                            :model.sync="blockForm.block_remaining_number.text_after_remaining_number"
                                            :config.sync="configFormInput.configFieldTextAfterremainingnumber"
                                            @blur="handleValidateField(configFormInput.configFieldTextAfterremainingnumber)"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="blockForm.block_remaining_number?.display_content == 2" class="d-flex">
                                <div class="form-group row">
                                    <label class="col-sm-2 text-nowrap" style="min-width: 50px"
                                        >{{ $t('managerForm.settingPage.remainingRatio') }}≦
                                    </label>
                                    <div class="col-sm-9">
                                        <div class="d-flex">
                                            <InputText
                                                :model.sync="blockForm.block_remaining_number.remaining_ratio"
                                                :config.sync="configFormInput.configFieldRemainingRatio"
                                                @blur="handleValidateField(configFormInput.configFieldRemainingRatio)"
                                            />
                                            <span class="mt-2 ml-2">%</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-2 text-nowrap" style="min-width: 50px"
                                        >{{ $t('managerForm.settingPage.labelOther') }}
                                    </label>
                                    <div class="col-sm-9">
                                        <InputText
                                            :model.sync="blockForm.block_remaining_number.label_other"
                                            :config.sync="configFormInput.configFieldRemainingLabelOther"
                                            @blur="handleValidateField(configFormInput.configFieldRemainingLabelOther)"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row pt-3 border-top-1-color">
                                <label class="col-sm-2 text-nowrap">{{ $t('managerForm.settingPage.colorText') }} </label>
                                <div class="col-sm-9">
                                    <div class="form-group row">
                                        <div class="col-sm-2">
                                            <InputText
                                                style="max-width: 100px"
                                                :model.sync="blockForm.block_remaining_number.color_text"
                                                :config="{
                                                    type: 'color',
                                                    classCustom: 'form-control-color',
                                                    error: false
                                                }"
                                            />
                                        </div>
                                        <div class="col-sm-3">
                                            <InputText
                                                style="max-width: 100px"
                                                :model.sync="blockForm.block_remaining_number.color_text"
                                                :config="{
                                                    error: false,
                                                    maxlength: 7
                                                }"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="isActiveCheckNumberLimit" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.checkNumberLimit') }} </label>
                <div class="col-sm-9">
                    <div class="form-group row">
                        <div class="col-sm-3">
                            <Multiselect
                                style="max-width: 200px"
                                :id="`checkNumberLimit`"
                                :value.sync="blockForm.block_checkbox.operator_limit_check"
                                :options="OPTION_LIMIT_CHECK"
                                :config="{ trackBy: 'id', label: 'value', error: false, isRemove: false, searchable: false }"
                                @select="onHandleOperatorLimit"
                                @remove="onHandleRemoveOperatorLimit"
                            />
                        </div>
                        <div class="col-sm-5">
                            <InputText
                                :model.sync="blockForm.block_checkbox.number_limit_check"
                                :config.sync="configFormInput.configFieldNumberLimitCheck"
                                :disabled="!blockForm.block_checkbox.operator_limit_check"
                                @blur="handleValidateField(configFormInput.configFieldNumberLimitCheck, 'numberLimit')"
                            />
                        </div>
                    </div>
                    <span>{{ $t('managerForm.settingPage.noteCheckNumberLimit') }}</span>
                </div>
            </div>
            <div v-if="isActiveDisplayConfirm" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">
                    <p v-if="config?.type !== ALL_BLOCK_TYPE.BLOCK_DISPLAY_1 && config?.type !== ALL_BLOCK_TYPE.BLOCK_DISPLAY_2" class="mb-1">
                        {{ $t('managerForm.settingPage.confirmationPageDisplay1') }}
                    </p>
                    <p class="mb-0">{{ $t('managerForm.settingPage.confirmationPageDisplay2') }}</p>
                </label>
                <div class="col-sm-9">
                    <div class="d-flex flex-wrap" style="gap: 12px">
                        <div v-for="(confirm, idx) in CONFIRMATION_PAGE_DISPLAY" :key="idx">
                            <InputRadio
                                class="mr-4"
                                :model.sync="blockForm.confirmation_page_display"
                                :name="`confirmationPageDisplay`"
                                :id="`confirmationPageDisplay-${confirm.id}`"
                                :value="confirm.id"
                                :label="confirm.name"
                                :disabled="isDisabledDisplayConfirm"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <!-- 個人情報項目設定 -->
            <div v-if="isActivePersonalSettings" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                    >{{ $t('managerForm.settingPage.personalInformationItemSettings') }}
                </label>
                <div class="col-sm-9">
                    <InputCheckBox
                        class="mb-2"
                        :model.sync="blockForm.personal_information_setting"
                        :id="`check-personal_information_setting`"
                        :value="blockForm.personal_information_setting"
                        :label="`${$t('managerForm.settingPage.designatePersonalInformation')}`"
                    />
                    <span>{{ $t('managerForm.settingPage.notePersonalInformationItemSettings') }}</span>
                </div>
            </div>
            <!-- 未選択ラベル -->
            <div v-if="isActivePlaceholderSelect" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.placeholderSelect') }} </label>
                <div class="col-sm-9">
                    <InputText
                        class="mb-2"
                        style="max-width: 280px"
                        :model.sync="blockForm.unselected_label"
                        :config.sync="configFormInput.configFieldPlaceholder"
                        @blur="handleValidateField(configFormInput.configFieldPlaceholder)"
                    />
                </div>
            </div>
            <!-- その他選択肢の 最大文字数 -->
            <div v-if="isActiveMaxcharacters" class="form-group row pt-3 border-top-1-color">
                <label v-if="LABEL_TYPE_1.includes(config?.type)" class="col-sm-2 text-nowrap" style="min-width: 190px"
                    >{{ $t('managerForm.settingPage.maxCharactersInput') }} <span class="text-danger">*</span></label
                >
                <label v-else-if="LABEL_TYPE_2.includes(config?.type)" class="col-sm-2 text-nowrap" style="min-width: 190px"
                    >{{ $t('managerForm.settingPage.maxCharactersInput') }}(入力欄毎) <span class="text-danger">*</span></label
                >
                <label v-else class="col-sm-2 text-nowrap" style="min-width: 190px"
                    >{{ $t('managerForm.settingPage.maxCharacters') }} <span class="text-danger">*</span></label
                >
                <div v-if="!isNumericValueIncludingDecimalPoint" class="col-sm-9" :class="`${isTypeValueNumerical ? 'row align-items-center' : ''}`">
                    <label v-if="isTypeValueNumerical" class="mr-3">{{ $t('managerForm.settingPage.numberOfDigits') }}</label>
                    <InputText
                        class="mb-2"
                        style="max-width: 300px"
                        :model.sync="blockForm.max_characters"
                        :config.sync="configFormInput.configFieldMaxCharacters"
                        :disabled="isDisabledMaxcharacters"
                        @blur="handleValidateField(configFormInput.configFieldMaxCharacters, 'maxCharacters')"
                    />
                    <span
                        v-if="
                            ![
                                ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX,
                                ALL_BLOCK_TYPE.BLOCK_INPUT,
                                ALL_BLOCK_TYPE.BLOCK_FULL_NAME,
                                ALL_BLOCK_TYPE.BLOCK_PARAMETER_ACQUISITION
                            ].includes(config?.type)
                        "
                        >{{ $t('managerForm.settingPage.noteMaxCharacters') }}</span
                    >
                    <span v-else>{{ $t('managerForm.settingPage.noteMaxCharactersInput') }}</span>
                </div>
                <div v-else>
                    <!-- 桁数 -->
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.numberOfDigits') }} </label>
                        <div class="col-sm-6">
                            <InputText
                                class="mb-2"
                                :model.sync="blockForm.block_input.number_of_digits"
                                :config.sync="configFormInput.configFieldNumberOfDigits"
                                @blur="handleValidateField(configFormInput.configFieldNumberOfDigits, 'numberOfDigits')"
                                :disabled="false"
                            />
                        </div>
                    </div>
                    <!-- 小数点以下桁数 -->
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap" style="min-width: 190px"
                            >{{ $t('managerForm.settingPage.numberOfDecimalPlaces') }}
                        </label>
                        <div class="col-sm-6">
                            <InputText
                                class="mb-2"
                                :model.sync="blockForm.block_input.number_of_decimal_places"
                                :config.sync="configFormInput.configFieldNumberOfDecimalPlaces"
                                @blur="handleValidateField(configFormInput.configFieldNumberOfDecimalPlaces, 'numberOfDecimalPlaces')"
                                :disabled="false"
                            />
                        </div>
                    </div>
                    <span v-if="config?.type !== ALL_BLOCK_TYPE.BLOCK_TEXTAREA">
                        <span
                            v-if="
                                [
                                    ALL_BLOCK_TYPE.BLOCK_FULL_NAME,
                                    ALL_BLOCK_TYPE.BLOCK_INPUT,
                                    ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX,
                                    ALL_BLOCK_TYPE.BLOCK_PARAMETER_ACQUISITION
                                ].includes(config?.type)
                            "
                            >{{ $t('managerForm.settingPage.noteMaxCharactersInput') }}</span
                        >
                        <span v-else>{{ $t('managerForm.settingPage.noteMaxCharacters') }}</span>
                    </span>
                </div>
            </div>

            <div v-if="isActiveDuplicateInput" class="form-group row">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.duplicateInput') }} </label>
                <div class="col-sm-9">
                    <div class="d-flex flex-wrap" style="gap: 12px">
                        <div v-for="(duplicateItem, idx) in OPTION_YES_NO" :key="idx">
                            <InputRadio
                                class="mr-4"
                                :model.sync="blockForm.block_parameter.is_duplicate"
                                :name="`duplicateInput`"
                                :id="`duplicateInput-${duplicateItem.id}`"
                                :value="duplicateItem.id"
                                :label="duplicateItem.value"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="isActiveAutocomplete" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.autocompleteInput') }} </label>
                <div class="col-sm-9">
                    <div class="d-flex flex-wrap mb-3" style="gap: 12px">
                        <div v-for="(autoComplete, idx) in OPTION_YES_NO" :key="idx">
                            <InputRadio
                                class="mr-4"
                                :model.sync="blockForm.block_input.auto_complete"
                                :name="`autocompleteInput`"
                                :id="`autocompleteInput-${autoComplete.id}`"
                                :value="autoComplete.id"
                                :label="autoComplete.value"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="isActiveConfirmInputTwice" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.confirmInputTwice') }} </label>
                <div class="col-sm-9">
                    <div class="d-flex flex-wrap mb-3" style="gap: 12px">
                        <div v-for="(checkTwice, idx) in OPTION_YES_NO" :key="idx">
                            <InputRadio
                                class="mr-4"
                                :model.sync="blockForm.block_input.confirm_input_twice"
                                :name="`confirmInputTwice`"
                                :id="`confirmInputTwice-${checkTwice.id}`"
                                :value="checkTwice.id"
                                :label="checkTwice.value"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="isActiveDisplayedPerLine" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.numberOfItemsDisplayedPerLine') }}</label>
                <div class="col-sm-9">
                    <Multiselect
                        style="max-width: 200px"
                        :id="`numberOfItemsDisplayedPerLine`"
                        :value.sync="blockForm.number_of_items_displayed_per_line"
                        :options="NUMBER_DISPLAY_PER_LINE"
                        :config="{ trackBy: '', label: '', error: false, isRemove: false, searchable: false }"
                    />
                </div>
            </div>
            <!-- 選択肢配置指定 -->
            <template v-if="isActivePlacement">
                <div class="form-group row pt-3 border-top-1-color">
                    <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{
                        $t('managerForm.settingPage.choicePlacementSpecificationQuestion')
                    }}</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap" style="gap: 12px">
                            <div v-for="(alginText, idx) in LIST_TEXT_ALIGN" :key="idx">
                                <InputRadio
                                    class="mr-4"
                                    :model.sync="blockForm.choice_placement_specification_question"
                                    :name="`choicePlacementSpecificationQuestion`"
                                    :id="`choicePlacementSpecificationQuestion-${alginText.id}`"
                                    :value="alginText.value"
                                    :label="alginText.label"
                                />
                            </div>
                        </div>
                        <p class="my-3">
                            {{ $t('managerForm.settingPage.propertiesDesginDefault') }}
                            {{
                                onHandleRenderTextPlacement(
                                    LIST_TEXT_ALIGN,
                                    onHandleGetValueTextAlign(inforSettingDesign.table_settings.question_text_alignment.horizontal)
                                )
                            }}
                        </p>
                    </div>
                </div>
                <div class="form-group row pt-3 border-top-1-color">
                    <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{
                        $t('managerForm.settingPage.choicePlacementSpecificationAnswer')
                    }}</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap" style="gap: 12px">
                            <div v-for="(alginText, idx) in LIST_TEXT_ALIGN" :key="idx">
                                <InputRadio
                                    class="mr-4"
                                    :model.sync="blockForm.choice_placement_specification_answer"
                                    :name="`choicePlacementSpecificationAnswer`"
                                    :id="`choicePlacementSpecificationAnswer-${alginText.id}`"
                                    :value="alginText.value"
                                    :label="alginText.label"
                                />
                            </div>
                        </div>
                        <p class="my-3">
                            {{ $t('managerForm.settingPage.propertiesDesginDefault') }}
                            {{
                                onHandleRenderTextPlacement(
                                    LIST_TEXT_ALIGN,
                                    onHandleGetValueTextAlign(inforSettingDesign.table_settings.answer_text_alignment.horizontal)
                                )
                            }}
                        </p>
                    </div>
                </div>
            </template>
            <!-- レイアウト	 -->
            <div v-if="isActiveLayout" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.layout') }}</label>
                <div class="col-sm-9">
                    <div class="d-flex flex-wrap" style="gap: 12px">
                        <div v-for="(alginText, idx) in LAYOUT_TYPE" :key="idx">
                            <InputRadio
                                class="mr-4"
                                :model.sync="blockForm.layout"
                                :name="`layout`"
                                :id="`layout-${alginText.id}`"
                                :value="alginText.value"
                                :label="alginText.label"
                            />
                        </div>
                    </div>
                    <p class="my-3">
                        {{ $t('managerForm.settingPage.propertiesDesginDefault') }}
                        {{ onHandleRenderTextLayout(LAYOUT_TYPE, inforSettingDesign.table_settings.question_layout) }}
                    </p>
                </div>
            </div>
            <!-- セル背景色 -->
            <div v-if="isActiveBackgroundColor" class="form-group row pt-3 border-top-1-color">
                <div class="col-sm-3 d-flex flex-column">
                    <label class="text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.cellBackgroundColor') }}</label>
                    <div>
                        <!-- ページデザインに戻す -->
                        <button v-if="isVisibledResetDesign" type="button" class="btn text-nowrap return__page--design" @click="handleReturnToDesign">
                            {{ $t('managerForm.settingPage.returnToPageDesign') }}
                        </button>
                    </div>
                </div>
                <div v-if="config?.type !== ALL_BLOCK_TYPE.BLOCK_DISPLAY_1" class="col-sm-9">
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap">{{ $t('managerForm.settingPage.backgroundColorOfQuestionField') }}</label>
                        <div class="col-sm-9">
                            <div class="form-group row">
                                <div class="col-sm-2">
                                    <InputText
                                        style="max-width: 100px"
                                        :model.sync="blockForm.cell_background_color.bg_question"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                        :disabled="blockForm.cell_background_color.is_bg_question_default"
                                    />
                                </div>
                                <div class="col-sm-3">
                                    <InputText
                                        style="max-width: 100px"
                                        :model.sync="blockForm.cell_background_color.bg_question"
                                        :config="{
                                            placeholder: '#',
                                            error: false,
                                            maxlength: 7
                                        }"
                                        :disabled="blockForm.cell_background_color.is_bg_question_default"
                                    />
                                </div>
                                <div class="mt-2">
                                    <InputCheckBox
                                        :model.sync="blockForm.cell_background_color.is_bg_question_default"
                                        :id="`check-is_bg_question_default`"
                                        :value="blockForm.cell_background_color.is_bg_question_default"
                                        :label="`共通デザインを適用する`"
                                        @change="onHandleSetCellColor"
                                    />
                                </div>
                            </div>
                            <div class="my-3 d-flex align-items-center">
                                <p class="mb-0">
                                    {{ $t('managerForm.settingPage.propertiesDesginDefault') }}
                                </p>
                                <InputText
                                    style="min-width: 100px"
                                    :model.sync="inforSettingDesign.table_settings.cell_background_color.question_background_color"
                                    :config="{
                                        type: 'color',
                                        classCustom: 'form-control-color',
                                        error: false
                                    }"
                                    :disabled="true"
                                />
                                <p class="mb-0 ml-2">
                                    {{ inforSettingDesign.table_settings.cell_background_color.question_background_color }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap">{{ $t('managerForm.settingPage.backgroundColorOfAnswerColumn') }}</label>
                        <div class="col-sm-9">
                            <div class="form-group row">
                                <div class="col-sm-2">
                                    <InputText
                                        style="max-width: 100px"
                                        :model.sync="blockForm.cell_background_color.bg_answer"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                        :disabled="blockForm.cell_background_color.is_bg_answer_default"
                                    />
                                </div>
                                <div class="col-sm-3">
                                    <InputText
                                        style="max-width: 100px"
                                        :model.sync="blockForm.cell_background_color.bg_answer"
                                        :config="{
                                            placeholder: '#',
                                            error: false,
                                            maxlength: 7
                                        }"
                                        :disabled="blockForm.cell_background_color.is_bg_answer_default"
                                    />
                                </div>
                                <div class="mt-2">
                                    <InputCheckBox
                                        :model.sync="blockForm.cell_background_color.is_bg_answer_default"
                                        :id="`check-is_bg_answer_default`"
                                        :value="blockForm.cell_background_color.is_bg_answer_default"
                                        :label="`共通デザインを適用する`"
                                        @change="onHandleSetCellColor"
                                    />
                                </div>
                            </div>
                            <div class="my-3 d-flex align-items-center">
                                <p class="mb-0">
                                    {{ $t('managerForm.settingPage.propertiesDesginDefault') }}
                                </p>
                                <InputText
                                    style="min-width: 100px"
                                    :model.sync="inforSettingDesign.table_settings.cell_background_color.answer_background_color"
                                    :config="{
                                        type: 'color',
                                        classCustom: 'form-control-color',
                                        error: false
                                    }"
                                    :disabled="true"
                                />
                                <p class="mb-0 ml-2">
                                    {{ inforSettingDesign.table_settings.cell_background_color.answer_background_color }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="col-sm-9">
                    <div class="form-group row">
                        <div class="col-sm-2">
                            <InputText
                                style="max-width: 100px"
                                :model.sync="blockForm.cell_background_color.bg_answer"
                                :config="{
                                    type: 'color',
                                    classCustom: 'form-control-color',
                                    error: false
                                }"
                                :disabled="blockForm.cell_background_color.is_bg_answer_default"
                            />
                        </div>

                        <div class="col-sm-2">
                            <InputText
                                style="max-width: 100px"
                                :model.sync="blockForm.cell_background_color.bg_answer"
                                :config="{
                                    placeholder: '#',
                                    error: false,
                                    maxlength: 7
                                }"
                                :disabled="blockForm.cell_background_color.is_bg_answer_default"
                            />
                        </div>
                        <div class="mt-2">
                            <InputCheckBox
                                :model.sync="blockForm.cell_background_color.is_bg_answer_default"
                                :id="`check-is_bg_answer_default`"
                                :value="blockForm.cell_background_color.is_bg_answer_default"
                                :label="`共通デザインを適用する`"
                                @change="onHandleSetCellColor"
                            />
                        </div>
                    </div>
                    <div class="my-3 d-flex align-items-center">
                        <p class="mb-0">
                            {{ $t('managerForm.settingPage.propertiesDesginDefault') }}
                        </p>
                        <InputText
                            style="min-width: 100px"
                            :model.sync="inforSettingDesign.table_settings.cell_background_color.answer_background_color"
                            :config="{
                                type: 'color',
                                classCustom: 'form-control-color',
                                error: false
                            }"
                            :disabled="true"
                        />
                        <p class="mb-0 ml-2">
                            {{ inforSettingDesign.table_settings.cell_background_color.answer_background_color }}
                        </p>
                    </div>
                </div>
            </div>

            <div v-if="isActiveInputConditions" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{
                    [ALL_BLOCK_TYPE.BLOCK_DISPLAY_1, ALL_BLOCK_TYPE.BLOCK_DISPLAY_2].includes(config.type)
                        ? $t('managerForm.settingPage.inputConditions_Div')
                        : $t('managerForm.settingPage.inputConditions')
                }}</label>
                <div v-if="listBlockConditionComputed.length > 0" class="col-sm-9">
                    <p>{{ $t('managerForm.settingPage.noteInputConditions') }}</p>
                    <div class="d-flex flex-wrap mb-3" style="gap: 12px">
                        <div v-for="(conditionItem, idx) in LIST_CHOICE_CONDITION" :key="idx">
                            <InputRadio
                                class="mr-4"
                                :model.sync="blockForm.input_condition.type"
                                :name="`inputConditions`"
                                :id="`inputConditions-${conditionItem.id}`"
                                :value="conditionItem.value"
                                :label="conditionItem.label"
                            />
                        </div>
                    </div>
                    <TableCondition :formBlock.sync="blockForm" :configFormInput="configFormInput" :listBlockCondition="listBlockConditionComputed" />
                </div>
                <div v-else class="col-sm-9">
                    <p>{{ $t('managerForm.settingPage.noteNoOtherBlocks') }}</p>
                </div>
            </div>
            <div v-if="isActiveConditionsDoNotMatch" class="form-group row pt-3 border-top-1-color">
                <label class="col-sm-2 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingPage.ifConditionsDoNotMatch') }} </label>
                <div class="col-sm-9">
                    <div class="d-flex flex-wrap" style="gap: 12px">
                        <div v-for="(matchItem, idx) in MATCH_CHOICE_CONDITION" :key="idx">
                            <InputRadio
                                class="mr-4"
                                :model.sync="blockForm.input_condition.status"
                                :name="`ifConditionsDoNotMatch`"
                                :id="`ifConditionsDoNotMatch-${matchItem.id}`"
                                :value="matchItem.id"
                                :label="matchItem.value"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AdditionalSettings
            v-else
            ref="additionalSettings"
            @back="handleBackStep1"
            @save="handleSaveStep2"
            :formBlock="blockForm"
            :configFormInput="configFormInput"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { cloneDeep } from 'lodash';
import {
    CONFIRMATION_PAGE_DISPLAY,
    LIST_TEXT_ALIGN,
    LAYOUT_TYPE,
    LIST_CHOICE_CONDITION,
    MATCH_CHOICE_CONDITION,
    OPTION_LIMIT_CHECK,
    OPTION_AGE_CONDITION,
    OPTION_YES_NO,
    OPTION_FORMAT_DATE,
    OPTION_CALENDAR_WEST_TIME,
    DISPLAY_CONTENT_BLOCK_REMAINING,
    LIST_MATCHING_CONDITION,
    OPTION_SOURCE_PARAMS
} from './constants';
import {
    ORDER_REQUIRED,
    LABEL,
    DISPLAY_CONFIRM,
    PERSONAL_SETTINGS,
    LAYOUT,
    BACKGROUND_COLOR,
    INPUT_CONDITIONS,
    LABEL_TYPE_1,
    LABEL_TYPE_2,
    VISIABLE_FILED_SERIAL_CODE_SETBLOCK
} from './listTypeActiveField';
import { InputText, InputCheckBox, InputRadio } from '@/components/Input';
import { validateField, validateAllField } from '@/utils/validate';
import { onScrollToFieldError } from '@/utils/handlers';
import { managerFormMethods } from '@/state/helpers';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { onHandleGetValueTextAlign } from '../../iframe-page/handlers';
import { PAGE_TYPES } from '../../constants';

import Editor from '@/components/Editor/main.vue';
import Multiselect from '@/components/Multiselect/main.vue';
import ActionOptionSelectCommon from './components/action-option-common.vue';
import TableCondition from './components/table-condition.vue';
import UploadFileCommon from '@/components/Uploads/Files/main.vue';
import TextareaComponent from '@/components/Textarea/main.vue';
import AdditionalSettings from './components/additional-settings.vue';
import { toNumber } from 'lodash';

export default {
    name: 'SettingBlockForm',
    components: {
        InputRadio,
        InputText,
        InputCheckBox,
        Editor,
        Multiselect,
        ActionOptionSelectCommon,
        TableCondition,
        UploadFileCommon,
        TextareaComponent,
        AdditionalSettings
    },
    props: {
        config: {
            type: Object,
            required: true,
            default: () => null
        },
        formBlock: {
            type: Object,
            required: true,
            default: () => null
        },
        configFormInput: {
            type: Object,
            required: true,
            default: () => null
        },
        actionTimeAddBlock: {
            type: Number,
            default: () => null
        },
        bgrDefault: {
            type: Object,
            default: () => null
        },
        inforSettingDesign: {
            type: Object,
            default: () => null
        },
        listTypeInput: {
            type: Array,
            default: () => []
        },
        listBlockCondition: {
            type: Array,
            default: () => []
        },
        idPrefix: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            PAGE_TYPES: PAGE_TYPES,
            CONFIRMATION_PAGE_DISPLAY: CONFIRMATION_PAGE_DISPLAY,
            LIST_TEXT_ALIGN: LIST_TEXT_ALIGN,
            LAYOUT_TYPE: LAYOUT_TYPE,
            LIST_CHOICE_CONDITION: LIST_CHOICE_CONDITION,
            MATCH_CHOICE_CONDITION: MATCH_CHOICE_CONDITION,
            OPTION_LIMIT_CHECK: OPTION_LIMIT_CHECK,
            OPTION_AGE_CONDITION: OPTION_AGE_CONDITION,
            OPTION_YES_NO: OPTION_YES_NO,
            OPTION_FORMAT_DATE: OPTION_FORMAT_DATE,
            OPTION_CALENDAR_WEST_TIME: OPTION_CALENDAR_WEST_TIME,
            DISPLAY_CONTENT_BLOCK_REMAINING: DISPLAY_CONTENT_BLOCK_REMAINING,
            LIST_MATCHING_CONDITION: LIST_MATCHING_CONDITION,
            OPTION_SOURCE_PARAMS: OPTION_SOURCE_PARAMS,
            NUMBER_DISPLAY_PER_LINE: Array.from({ length: 20 }).map((_, i) => i + 1),
            LABEL_TYPE_1: LABEL_TYPE_1,
            LABEL_TYPE_2: LABEL_TYPE_2,
            ALL_BLOCK_TYPE: ALL_BLOCK_TYPE,
            listOptionText: this.listTypeInput,
            blockForm: cloneDeep(this.formBlock),
            configKeywordUploadFile: {
                allowedExtension: ['txt', 'plain', 'csv'],
                allowedSize: 1024,
                isPreview: false
            },
            LIST_BLOCK_SEARCH_ADDRESS: [],
            typeFormatInput: ['数値', '数値(小数点を含む)'],
            numericalValue: 'numerical_value',
            isSettingStep1: true,
            sttSubmited: false
        };
    },
    computed: {
        ...mapState({
            ...mapState('managerForm', ['listBlockCreated'])
        }),
        listBlockConditionComputed() {
            return this.listBlockCondition.filter((item) => item.id !== this.blockForm.id);
        },

        isBorderSettingTypeNone() {
            const borderSettingType = this.inforSettingDesign?.table_settings?.border_setting?.type;
            const typeValue = typeof borderSettingType === 'object' && borderSettingType !== null ? borderSettingType.value : borderSettingType;
            return typeValue === 'none';
        },

        isScreenComplete() {
            return [PAGE_TYPES._A[2]].includes(this.config?.typeScreen);
        },
        isScreenLotteryTypeB() {
            return [PAGE_TYPES._B[1], PAGE_TYPES._B[2], PAGE_TYPES._B[3]].includes(this.config?.typeScreen);
        },
        isScreenPrizeSerialTypeB() {
            return this.config?.typeScreen === 'prize_serial';
        },

        isNumericValueIncludingDecimalPoint() {
            return this.blockForm?.input_format?.type_input === 'numeric_value_including_decimal_point';
        },

        isDisabledDisplayConfirm() {
            return this.blockForm.order_required;
        },

        isVisibledUncheck() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_CHECKBOX];
            if (arrayType.includes(this.config?.type)) return true;
            return !this.blockForm.order_required;
        },

        actionSelectCommon() {
            let arrayType = [
                ALL_BLOCK_TYPE.BLOCK_RADIO,
                ALL_BLOCK_TYPE.BLOCK_SELECT,
                ALL_BLOCK_TYPE.BLOCK_CHECKBOX,
                ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE,
                ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY
            ];
            return arrayType.includes(this.config?.type);
        },

        isActiveOrderRequired() {
            return ORDER_REQUIRED.includes(this.config?.type);
        },
        isDisabledOrderRequired() {
            return this.config?.is_serial_code_type_b;
        },

        isActiveLabel() {
            return LABEL.includes(this.config?.type);
        },

        // 取得元
        isActiveSourceParam() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_PARAMETER_ACQUISITION];
            return arrayType.includes(this.config?.type);
        },
        // パラメータ名
        isActiveParamName() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_PARAMETER_ACQUISITION];
            return arrayType.includes(this.config?.type);
        },
        // エラーリダイレクト先 URL
        isActiveParamURL() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_PARAMETER_ACQUISITION];
            return arrayType.includes(this.config?.type);
        },

        isActiveMatchingCondition() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX];
            return arrayType.includes(this.config?.type);
        },

        isActiveFieldMaskDisplay() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX];
            return arrayType.includes(this.config?.type);
        },

        isActiveKeywordUpload() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX];
            return arrayType.includes(this.config?.type);
        },

        isActivePhonePlaceholder() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER];
            return arrayType.includes(this.config?.type);
        },

        isActiveDiv2Label() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_DISPLAY_2];
            return arrayType.includes(this.config?.type);
        },

        isActiveFormatYear() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_DATE];
            return arrayType.includes(this.config?.type);
        },

        isActiveFormatMonthDay() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_DATE];
            return arrayType.includes(this.config?.type);
        },

        isActiveMaximumFileSize() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE];
            return arrayType.includes(this.config?.type);
        },
        isActiveAllowedExtensions() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE];
            return arrayType.includes(this.config?.type);
        },

        isActiveIncludesOfInput() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_INPUT];
            return arrayType.includes(this.config?.type);
        },

        // 入力形式	DefineIncludesInput
        isActiveDefineIncludesInput() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_INPUT, ALL_BLOCK_TYPE.BLOCK_FULL_NAME];
            return arrayType.includes(this.config?.type);
        },

        // 入力欄サイズ
        isActiveFieldSize() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_INPUT, ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX];
            return arrayType.includes(this.config?.type);
        },
        // オートコンプリート
        isActiveAutocomplete() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_INPUT];
            return arrayType.includes(this.config?.type) && this.blockForm.input_format?.value === 'メールアドレス';
        },

        // テキストの二度入力確認
        isActiveConfirmInputTwice() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_INPUT];
            return arrayType.includes(this.config?.type);
        },
        // 上記以外の選択肢 optionOther
        isActiveOptionOther() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_RADIO, ALL_BLOCK_TYPE.BLOCK_CHECKBOX, ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY];
            if (this.config?.type === ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY) {
                return this.blockForm.order_required ? false : true;
            }
            return arrayType.includes(this.config?.type);
        },
        // 残数
        isActiveRemainingNumber() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY];
            return arrayType.includes(this.config?.type);
        },

        // チェック数制限
        isActiveCheckNumberLimit() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_CHECKBOX];
            return arrayType.includes(this.config?.type);
        },

        // 未入力時の
        // 確認ページ表示
        isActiveDisplayConfirm() {
            return (
                DISPLAY_CONFIRM.includes(this.config?.type) &&
                !this.isScreenComplete &&
                !this.isScreenLotteryTypeB &&
                !VISIABLE_FILED_SERIAL_CODE_SETBLOCK.includes(this.idPrefix)
            );
        },

        isActivePersonalSettings() {
            return PERSONAL_SETTINGS.includes(this.config?.type);
        },

        isActivePlaceholderSelect() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_SELECT, ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE];
            return arrayType.includes(this.config?.type);
        },

        isActivePlaceholderInput() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_INPUT, ALL_BLOCK_TYPE.BLOCK_TEXTAREA, ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX];
            return arrayType.includes(this.config?.type);
        },
        isActivePlaceholderPostcode() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE];
            return arrayType.includes(this.config?.type);
        },
        isActiveFeatureSearchAddress() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE];
            return arrayType.includes(this.config?.type);
        },
        isActivePlaceholderFullname() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_FULL_NAME];
            return arrayType.includes(this.config?.type);
        },

        isActiveSizeTextarea() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_TEXTAREA];
            return arrayType.includes(this.config?.type);
        },

        isActiveMaxcharacters() {
            let arrayType = [
                ALL_BLOCK_TYPE.BLOCK_RADIO,
                ALL_BLOCK_TYPE.BLOCK_CHECKBOX,
                ALL_BLOCK_TYPE.BLOCK_INPUT,
                ALL_BLOCK_TYPE.BLOCK_TEXTAREA,
                ALL_BLOCK_TYPE.BLOCK_FULL_NAME,
                ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX,
                ALL_BLOCK_TYPE.BLOCK_PARAMETER_ACQUISITION
            ];
            return arrayType.includes(this.config?.type);
        },

        // 重複入力チェック
        isActiveDuplicateInput() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_PARAMETER_ACQUISITION];
            return arrayType.includes(this.config?.type);
        },

        // 1行に表示する項目数
        isActiveDisplayedPerLine() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_RADIO, ALL_BLOCK_TYPE.BLOCK_CHECKBOX, ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY];
            return arrayType.includes(this.config?.type);
        },

        isActivePlacement() {
            let arrayType = [ALL_BLOCK_TYPE.BLOCK_RADIO, ALL_BLOCK_TYPE.BLOCK_CHECKBOX, ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY];
            return arrayType.includes(this.config?.type);
        },

        isActiveLayout() {
            return LAYOUT.includes(this.config?.type);
        },

        isActiveBackgroundColor() {
            return BACKGROUND_COLOR.includes(this.config?.type);
        },
        // 入力条件
        isActiveInputConditions() {
            return (
                INPUT_CONDITIONS.includes(this.config?.type) &&
                !this.isScreenComplete &&
                !this.isScreenLotteryTypeB &&
                !this.config?.is_serial_code_type_b &&
                !VISIABLE_FILED_SERIAL_CODE_SETBLOCK.includes(this.idPrefix)
            );
        },

        isActiveConditionsDoNotMatch() {
            return (
                this.blockForm?.input_condition?.conditions?.length > 0 &&
                ![ALL_BLOCK_TYPE.BLOCK_DISPLAY_1, ALL_BLOCK_TYPE.BLOCK_DISPLAY_2].includes(this.config?.type)
            );
        },

        isDisabledMaxcharacters() {
            return (
                [ALL_BLOCK_TYPE.BLOCK_RADIO, ALL_BLOCK_TYPE.BLOCK_CHECKBOX, ALL_BLOCK_TYPE.BLOCK_SELECT].includes(this.blockForm.block_type) &&
                !this.blockForm.setting_others.other_use
            );
        },

        isVisibledResetDesign() {
            return (
                this.blockForm.cell_background_color.bg_question !== this.bgrDefault.bg_question ||
                this.blockForm.cell_background_color.bg_answer !== this.bgrDefault.bg_answer
            );
        },

        isTypeValueNumerical() {
            return [this.numericalValue].includes(this.blockForm.input_format?.type_input);
        }
    },
    methods: {
        ...managerFormMethods,
        onHandleGetValueTextAlign,

        onHandleChangeNameBlock(evtName) {
            if (!this.blockForm.label) this.blockForm.label = evtName;
        },

        handleValidateField(configField, typeAction = null) {
            let { configFieldMinimumNumber, configFieldMaximumNumber } = this.configFormInput;
            validateField(configField);
            switch (typeAction) {
                case 'maxCharacters':
                    this.blockForm.block_input.from_range = '';
                    this.blockForm.block_input.to_range = '';
                    this.handleChangeInputMaxCharacters();
                    break;
                case 'numberOfDecimalPlaces':
                    this.handleFieldNumberAfterDecimalPoint();
                    break;
                case 'numberOfDigits':
                    this.handleFieldNumberOfDigits();
                    break;
                case 'validDigitsAnswerAfterDecimalPoint':
                    this.handleChangeInputAfterDecimalPoint();
                    break;
                case 'numberLimit':
                    this.onHandleNumberLimit();
                    break;
                case 'numberMinMax':
                    this.validateCharacterMinMaxInput(configFieldMinimumNumber, configFieldMaximumNumber);
                    break;
                case 'fromRange':
                case 'toRange':
                    this.onHandleCompareRange(this.blockForm.block_input.from_range, this.blockForm.block_input.to_range);
                    break;
                case 'compareYear':
                    this.validateBlockDateCompareYear();
                    break;
                case 'charactorExtensions':
                    this.validateCharactorFileSize();
                    break;
                case 'validateParamName':
                    this.validateCharactorParamName();
                    break;
                case 'vKeywordUpload':
                    this.validateKeywordUpload();
                    validateField(configField);
                    break;
            }
        },

        validateKeywordUpload() {
            let isError = true;
            if (this.blockForm.block_type !== ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX) return isError;
            let { configFieldKeywordUpload } = this.configFormInput;
            configFieldKeywordUpload.typesValidate = configFieldKeywordUpload.typesValidate.filter((type) => type !== 'maxCustom');
            const lines = this.blockForm.block_keyword_box.keyword_characters.split('\n');
            for (let i = 0; i < lines.length; i++) {
                const line = lines[i];
                if (line.length > this.blockForm.max_characters) {
                    isError = false;
                    configFieldKeywordUpload.typesValidate.push('maxCustom');
                    break;
                }
            }
            return isError;
        },

        validateCharactorFileSize() {
            let isError = true;
            let { configFieldAllowedExtensions } = this.configFormInput;
            const regex = /^\s*[A-Za-z0-9]+\s*(\s*,\s*[A-Za-z0-9]+\s*)*$/;
            if (configFieldAllowedExtensions.valueSync && !regex.test(configFieldAllowedExtensions.valueSync)) {
                isError = false;
                configFieldAllowedExtensions.error = true;
                configFieldAllowedExtensions.errorCustomMess = `${configFieldAllowedExtensions.errorField}には不正な拡張子が含まれています。`;
            }
            return isError;
        },

        formatExtension() {
            this.blockForm.block_upload_file.allowed_extensions = this.blockForm.block_upload_file.allowed_extensions.replace(/\s+/g, '');
        },

        validateCharactorParamName() {
            let isError = true;
            let { configFieldParamName } = this.configFormInput;
            const regex = /^[a-zA-Z0-9.\-!#$%&'~|`+*_^]+$/;
            if (
                configFieldParamName.valueSync &&
                configFieldParamName.valueSync.length < configFieldParamName.length &&
                !regex.test(configFieldParamName.valueSync)
            ) {
                isError = false;
                configFieldParamName.error = true;
                configFieldParamName.errorCustomMess = `${configFieldParamName.errorField}に英数字、'.^-!#$%&'~|\\\`+*_' 以外は入力できません。`;
            }
            return isError;
        },

        validateBlockDateCompareYear() {
            let isError = true;
            let { configFieldLowerLimit, configFieldUpperLimit } = this.configFormInput;
            if (this.blockForm.block_date?.format_year?.type == 1) return isError;
            if (!configFieldLowerLimit.error && !configFieldUpperLimit.error && configFieldLowerLimit.valueSync && configFieldUpperLimit.valueSync) {
                if (configFieldLowerLimit.valueSync >= configFieldUpperLimit.valueSync) {
                    isError = false;
                    configFieldLowerLimit.error = true;
                    configFieldLowerLimit.errorCustomMess = `${configFieldLowerLimit.errorField}が上限を超えています。`;
                }
            }
            return isError;
        },

        onHandleNumberLimit() {
            let { block_checkbox, setting_others } = this.blockForm;
            let check = true;
            if (!block_checkbox.number_limit_check || block_checkbox.number_limit_check === '0') return check;
            if (!setting_others.uncheck_use) {
                this.configFormInput.configFieldNumberLimitCheck.error = false;
                return check;
            }
            if (block_checkbox.operator_limit_check?.value === '=' || block_checkbox.operator_limit_check?.value === '≧') {
                check = !(block_checkbox.number_limit_check > 1);
                this.configFormInput.configFieldNumberLimitCheck.error = !!(block_checkbox.number_limit_check > 1);
                this.configFormInput.configFieldNumberLimitCheck.errorCustomMess = 'チェック数制限に「1」以外は指定できません。';
            }
            return check;
        },

        onHandleCompareRange(from, to) {
            let checkCompare = true;
            let { configFieldToRange } = this.configFormInput;
            if (configFieldToRange.error) {
                checkCompare = false;
                return checkCompare;
            }
            if (!from || !to || this.isNumericValueIncludingDecimalPoint) return checkCompare;
            if (Number(to) <= Number(from)) {
                checkCompare = false;
                configFieldToRange.error = true;
                configFieldToRange.errorCompare = '回答値の有効範囲（最小）が回答値の有効範囲（最大）を超えています。';
            } else {
                configFieldToRange.error = false;
                configFieldToRange.errorCompare = '';
            }
            return checkCompare;
        },

        validateCharacterMinMaxInput(minConfig, maxConfig) {
            let minMaxCheck = true;
            if (minConfig.valueSync && maxConfig.valueSync && toNumber(minConfig.valueSync) > toNumber(maxConfig.valueSync)) {
                minMaxCheck = false;
                minConfig.error = true;
                minConfig.errorCustomMess = `${minConfig.errorField}が${maxConfig.errorField}を超えています。`;
            }
            return minMaxCheck;
        },

        handleFieldNumberAfterDecimalPoint() {
            let decimalPointCheck = true;
            let { block_input } = this.blockForm;
            let { configFieldNumberOfDigits, configFieldFromRange, configFieldToRange, configFieldNumberAfterDecimalPoint } = this.configFormInput;
            configFieldNumberAfterDecimalPoint.max = block_input.number_of_decimal_places;
            configFieldNumberAfterDecimalPoint.error = false;
            block_input.number_after_decimal_point = '';
            decimalPointCheck = this.onHandleNumberOfDigitsWidthNumberAfterDecimalPoint(decimalPointCheck);
            if (this.isNumericValueIncludingDecimalPoint) {
                configFieldFromRange.error = false;
                configFieldToRange.error = false;
                if (!configFieldNumberOfDigits.error) {
                    configFieldFromRange.integer = Number(block_input.number_of_digits) - Number(block_input.number_of_decimal_places);
                    configFieldFromRange.decimal = Number(block_input.number_of_decimal_places);
                    configFieldToRange.integer = Number(block_input.number_of_digits) - Number(block_input.number_of_decimal_places);
                    configFieldToRange.decimal = Number(block_input.number_of_decimal_places);
                }
            }
            return decimalPointCheck;
        },

        handleFieldNumberOfDigits() {
            let digitCheck = true;
            let { block_input } = this.blockForm;
            let { configFieldFromRange, configFieldToRange, configFieldNumberAfterDecimalPoint } = this.configFormInput;
            if (!this.isNumericValueIncludingDecimalPoint) return digitCheck;
            configFieldFromRange.error = false;
            configFieldToRange.error = false;
            digitCheck = this.onHandleNumberOfDigitsWidthNumberAfterDecimalPoint(digitCheck);
            if (!configFieldNumberAfterDecimalPoint.error) {
                configFieldFromRange.integer = Number(block_input.number_of_digits) - Number(block_input.number_of_decimal_places);
                configFieldFromRange.decimal = Number(block_input.number_of_decimal_places);
                configFieldToRange.integer = Number(block_input.number_of_digits) - Number(block_input.number_of_decimal_places);
                configFieldToRange.decimal = Number(block_input.number_of_decimal_places);
            }
            return digitCheck;
        },

        onHandleNumberOfDigitsWidthNumberAfterDecimalPoint(isCheckValidate) {
            let { configFieldNumberOfDigits, configFieldNumberAfterDecimalPoint, configFieldNumberOfDecimalPlaces } = this.configFormInput;
            configFieldNumberOfDigits.messageCustom = false;
            configFieldNumberAfterDecimalPoint.error = false;

            if (Number(configFieldNumberOfDigits.valueSync) < Number(configFieldNumberOfDecimalPlaces.valueSync)) {
                isCheckValidate = false;
                configFieldNumberOfDigits.messageCustom = true;
                configFieldNumberOfDigits.error = true;
                configFieldNumberOfDecimalPlaces.error = true;
                configFieldNumberOfDigits.errorCustomMess = `1から1000までの正の整数を「${configFieldNumberOfDecimalPlaces.errorField} ≦${configFieldNumberOfDigits.errorField}」になるように入力してください。`;
                configFieldNumberOfDecimalPlaces.errorCustomMess = `0から100までの正の整数を「${configFieldNumberOfDecimalPlaces.errorField} ≦${configFieldNumberOfDigits.errorField}」になるように入力してください。`;
            }

            if (Number(configFieldNumberOfDecimalPlaces.valueSync) < Number(configFieldNumberAfterDecimalPoint.valueSync)) {
                isCheckValidate = false;
                configFieldNumberAfterDecimalPoint.messageCustom = true;
                configFieldNumberAfterDecimalPoint.error = true;
                configFieldNumberAfterDecimalPoint.errorCustomMess = `${configFieldNumberOfDecimalPlaces.valueSync}以下の正の整数を入力してください。`;
            }

            return isCheckValidate;
        },

        handleChangeInputAfterDecimalPoint() {
            let { block_input } = this.blockForm;
            let { configFieldFromRange, configFieldToRange, configFieldNumberOfDecimalPlaces, configFieldNumberAfterDecimalPoint } =
                this.configFormInput;
            configFieldFromRange.error = false;
            configFieldToRange.error = false;
            configFieldFromRange.decimal = Number(block_input.number_after_decimal_point);
            configFieldToRange.decimal = Number(block_input.number_after_decimal_point);

            if (Number(configFieldNumberOfDecimalPlaces.valueSync) < Number(configFieldNumberAfterDecimalPoint.valueSync)) {
                configFieldNumberAfterDecimalPoint.messageCustom = true;
                configFieldNumberAfterDecimalPoint.error = true;
                configFieldNumberAfterDecimalPoint.errorCustomMess = `${configFieldNumberOfDecimalPlaces.valueSync}以下の正の整数を入力してください。`;
            }
        },

        onHandleOperatorLimit() {
            this.configFormInput.configFieldNumberLimitCheck.typesValidate = ['required', 'max255', 'limit-input'];
            this.blockForm.block_checkbox.number_limit_check = '';
        },

        onHandleRemoveOperatorLimit() {
            this.blockForm.block_checkbox.number_limit_check = '';
            this.configFormInput.configFieldNumberLimitCheck.error = false;
            this.configFormInput.configFieldNumberLimitCheck.typesValidate = ['max255', 'limit-input'];
        },

        handleCancelBlock() {
            this.$emit('cancel', false);
        },

        handleSaveStep1() {
            this.sttSubmited = true;
            let checkOptionValue = this.actionSelectCommon && this.blockForm.option_value?.length === 0 ? false : true;
            let { configFieldMinimumNumber, configFieldMaximumNumber } = this.configFormInput;
            this.onHandleConditionOtherBeforeSave();
            let hasCharactorBlockKeywordbox = this.validateKeywordUpload();
            let check = validateAllField(this.configFormInput);
            let hasCompareRange = this.onHandleCompareRange(this.blockForm.block_input.from_range, this.blockForm.block_input.to_range);
            let hasNumberLimit = this.onHandleNumberLimit();
            let hasNumberMinMax = this.validateCharacterMinMaxInput(configFieldMinimumNumber, configFieldMaximumNumber);
            let hasCaseMaxChasters = this.handleChangeInputMaxCharacters();
            let hasDecimalAndDigits = this.onHandleNumberOfDigitsWidthNumberAfterDecimalPoint(true);
            let hasCompareBlockDate = this.validateBlockDateCompareYear();
            let hasCharactorBlockUpload = this.validateCharactorFileSize();
            let hasCharactorBlockGetParam = this.validateCharactorParamName();

            if (
                !check ||
                !hasCompareRange ||
                !hasNumberLimit ||
                !hasNumberMinMax ||
                !hasCaseMaxChasters ||
                !hasDecimalAndDigits ||
                !hasCompareBlockDate ||
                !hasCharactorBlockUpload ||
                !hasCharactorBlockGetParam ||
                !hasCharactorBlockKeywordbox ||
                !checkOptionValue
            ) {
                this.$nextTick(() => {
                    onScrollToFieldError();
                });
                return;
            }

            this.formatExtension();
            if (
                ![ALL_BLOCK_TYPE.BLOCK_PARAMETER_ACQUISITION, ALL_BLOCK_TYPE.BLOCK_DISPLAY_1, ALL_BLOCK_TYPE.BLOCK_DISPLAY_2].includes(
                    this.blockForm.block_type
                )
            ) {
                this.isSettingStep1 = !check;
                this.updateButtonEvent({ eventEditBlock: false, eventEditPage: false, eventEditBlockStep2: true });
            } else {
                this.$emit('showSave', !check);
                this.saveStateBlockForm(this.blockForm);
                this.updateButtonEvent({ eventEditBlock: false, eventEditPage: true, eventEditBlockStep2: false });
            }
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            this.sttSubmited = false;
        },

        onHandleConditionOtherBeforeSave() {
            let {
                configFieldLabelBlock,
                configFieldLabel_Q_Block1,
                configFieldLabel_A_Block2,
                configFieldMaximumFileSize,
                configFieldKeywordUpload,
                configFieldParamName,
                configFieldMaxCharacters,
                configFieldNumberOfDigits,
                configFieldLabelOther,
                configFieldNumberOfDecimalPlaces,
                configFieldLabelUncheck
            } = this.configFormInput;

            if (!this.isActiveLabel) {
                configFieldLabelBlock.typesValidate = [];
            }
            if (!this.isActiveDiv2Label) {
                configFieldLabel_Q_Block1.typesValidate = [];
                configFieldLabel_A_Block2.typesValidate = [];
            }
            if (!this.isActiveMaximumFileSize) {
                configFieldMaximumFileSize.typesValidate = [];
            }

            if (!this.isActiveKeywordUpload) {
                configFieldKeywordUpload.typesValidate = [];
            }

            if (!this.isActiveParamName) {
                configFieldParamName.typesValidate = [];
            }

            if (!this.actionSelectCommon) {
                this.configFormInput.validateArrayOption = this.configFormInput.validateArrayOption.map((vld) => {
                    return {
                        configFieldValue: {
                            ...vld.configFieldValue,
                            typesValidate: []
                        },
                        configFieldNumberOfReceptions: {
                            ...vld.configFieldNumberOfReceptions,
                            typesValidate: []
                        }
                    };
                });
            } else {
                if (this?.config?.type !== ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY) {
                    this.configFormInput.validateArrayOption = this.configFormInput.validateArrayOption.map((vld) => {
                        return {
                            configFieldValue: {
                                ...vld.configFieldValue
                            },
                            configFieldNumberOfReceptions: {
                                ...vld.configFieldNumberOfReceptions,
                                typesValidate: []
                            }
                        };
                    });
                }
            }

            if (!this.isActiveMaxcharacters) {
                configFieldMaxCharacters.typesValidate = [];
            }

            if (!this.isNumericValueIncludingDecimalPoint) {
                configFieldNumberOfDigits.typesValidate = [];
                configFieldNumberOfDecimalPlaces.typesValidate = [];
            }

            if (!this.isActiveOptionOther) {
                configFieldLabelOther.typesValidate = [];
                configFieldLabelUncheck.typesValidate = [];
            }
        },

        onHandleOtherUserCheckbox(isOtherUse) {
            let { configFieldLabelOther } = this.configFormInput;
            this.blockForm.setting_others.value_other_required = false;
            if (!isOtherUse) {
                configFieldLabelOther.typesValidate = [];
                configFieldLabelOther.error = false;
                this.blockForm.setting_others.label_other = 'その他';
            } else {
                configFieldLabelOther.typesValidate = ['required', 'max20'];
            }
        },

        onHandleUncheckUse(isUncheckUse) {
            let { configFieldLabelUncheck } = this.configFormInput;
            if (!isUncheckUse) {
                configFieldLabelUncheck.typesValidate = [];
                configFieldLabelUncheck.error = false;
                this.blockForm.setting_others.label_uncheck = [ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY, ALL_BLOCK_TYPE.BLOCK_RADIO].includes(
                    this.config?.type
                )
                    ? this.$t('managerForm.settingPage.uncheck')
                    : this.$t('managerForm.settingPage.uncheckCheckbox');
            } else {
                configFieldLabelUncheck.typesValidate = ['required', 'max20'];
            }
        },

        handleReturnToDesign() {
            this.blockForm.cell_background_color.bg_question = this.bgrDefault.bg_question;
            this.blockForm.cell_background_color.bg_answer = this.bgrDefault.bg_answer;
        },

        handleChangeTypeYear(typeYear, type = null) {
            let { block_date } = this.blockForm;
            let { configFieldLowerLimit, configFieldUpperLimit, configFieldPlaceholderYear } = this.configFormInput;
            if (type === 'change') {
                block_date.format_year.lower_limit = '';
                block_date.format_year.upper_limit = '';
            }
            if (typeYear === 2) {
                configFieldLowerLimit.typesValidate = ['required', 'max255', 'limit-input'];
                configFieldUpperLimit.typesValidate = ['required', 'max255', 'limit-input'];
            } else {
                configFieldLowerLimit.typesValidate = ['max255', 'limit-input'];
                configFieldUpperLimit.typesValidate = ['max255', 'limit-input'];
            }
            block_date.format_month_day.type = typeYear;
            configFieldLowerLimit.error = false;
            configFieldUpperLimit.error = false;
            configFieldPlaceholderYear.error = false;
        },

        onHandleChangeTypeCanlendar(typeCanlendar) {
            let { configFieldLowerLimit, configFieldUpperLimit } = this.configFormInput;
            if ([2, 3].includes(typeCanlendar)) {
                configFieldLowerLimit.min = 1872;
                configFieldUpperLimit.min = 1872;
            } else {
                configFieldLowerLimit.min = 1800;
                configFieldUpperLimit.min = 1800;
            }
        },

        handleChangeTypeMonthDay() {
            let { configFieldPlaceholderMonth, configFieldPlaceholderDay } = this.configFormInput;
            configFieldPlaceholderMonth.error = '';
            configFieldPlaceholderDay.error = '';
        },

        handleChangeRemainingItem() {
            this.blockForm.block_remaining_number.display_content = 1;
        },

        handleChangeDisplayContentItem(valueDisplay) {
            if (valueDisplay === 2) {
                this.configFormInput.configFieldRemainingRatio.typesValidate = ['required', 'max255', 'limit-input'];
                this.configFormInput.configFieldRemainingLabelOther.typesValidate = ['required', 'max255'];
            } else {
                this.configFormInput.configFieldRemainingRatio.typesValidate = ['max255', 'limit-input'];
                this.configFormInput.configFieldRemainingLabelOther.typesValidate = ['max255'];
            }
        },

        handleFileKeywordUpload(file) {
            this.blockForm.block_keyword_box.keyword_characters = file;
        },

        handleBackStep1(isBack) {
            this.updateButtonEvent({ eventEditBlock: true, eventEditPage: false, eventEditBlockStep2: false });
            this.isSettingStep1 = isBack;
        },
        handleSaveStep2(isSave) {
            this.onHandleTrimData();
            this.saveStateBlockForm(this.blockForm);
            this.$emit('showSave', isSave);
        },

        onHandleTrimData() {
            this.blockForm.block_name = this.blockForm.block_name.trim();
            this.blockForm.setting_others.label_other = this.blockForm.setting_others.label_other.trim();
            this.blockForm.setting_others.label_uncheck = this.blockForm.setting_others.label_uncheck.trim();
            this.blockForm.option_value = this.blockForm.option_value.map((op) => {
                op.value = op.value.trim();
                return op;
            });
        },

        handleChangeFeatureSearchAddress() {
            // blockPostcode.prefecture_insertion = null;
            // blockPostcode.city_insertion = null;
            // blockPostcode.town_area_name_insertion = null;
        },

        onHandleChangeInputFormat() {
            let { block_input } = this.blockForm;
            block_input.from_range = '';
            block_input.to_range = '';
            block_input.number_after_decimal_point = '';
            this.blockForm.max_characters = 255;
            if (this.isNumericValueIncludingDecimalPoint) {
                block_input.number_of_digits = 15;
                block_input.number_of_decimal_places = 5;
            }
            if (this.isTypeValueNumerical) {
                this.blockForm.max_characters = 10;
            }
            if (this.isActivePlaceholderFullname) {
                this.blockForm.max_characters = 100;
            }

            this.onHandleSetMaxcharacters();
        },

        onHandleSetMaxcharacters() {
            let {
                configFieldFromRange,
                configFieldToRange,
                configFieldMaxCharacters,
                configFieldNumberAfterDecimalPoint,
                configFieldNumberOfDigits,
                configFieldNumberOfDecimalPlaces
            } = this.configFormInput;

            configFieldMaxCharacters.max = 255;
            configFieldFromRange.error = false;
            configFieldToRange.error = false;
            configFieldMaxCharacters.error = false;
            configFieldNumberAfterDecimalPoint.error = false;
            configFieldMaxCharacters.errorField = this.$t('managerForm.settingPage.maxCharacters');
            if (this.isTypeValueNumerical) {
                configFieldMaxCharacters.max = 10;
                configFieldFromRange.typesValidate = ['integerMaxMin'];
                configFieldToRange.typesValidate = ['integerMaxMin'];
                configFieldToRange.maxlength = 11;
                configFieldToRange.maxlength = 11;
                configFieldMaxCharacters.errorField = this.$t('managerForm.settingPage.numberOfDigits');
            }
            if (this.isNumericValueIncludingDecimalPoint) {
                configFieldNumberOfDigits.error = false;
                configFieldNumberOfDecimalPlaces.error = false;
                configFieldNumberOfDigits.typesValidate = ['required', 'max255', 'limit-input'];
                configFieldNumberOfDecimalPlaces.typesValidate = ['required', 'max255', 'limit-input'];
                configFieldFromRange.typesValidate = ['integerDecimal'];
                configFieldToRange.typesValidate = ['integerDecimal'];
                configFieldFromRange.maxlength = '';
                configFieldToRange.maxlength = '';
            }
            if (this.isActivePlaceholderFullname) {
                configFieldMaxCharacters.max = 100;
            }

            if (this.LABEL_TYPE_2.includes(this.blockForm.block_type)) {
                configFieldMaxCharacters.errorField = `${this.$t('managerForm.settingPage.maxCharacters')}(入力欄毎) `;
                configFieldMaxCharacters.max = 100;
            }

            if (this.blockForm.block_type === ALL_BLOCK_TYPE.BLOCK_TEXTAREA) {
                configFieldMaxCharacters.max = 30000;
            }
        },

        handleChangeInputMaxCharacters() {
            let characterCheck = true;
            let { max_characters } = this.blockForm;
            let { configFieldFromRange, configFieldToRange, configFieldMaxCharacters, configFieldMaximumNumber, configFieldKeywordUpload } =
                this.configFormInput;
            if (this.isTypeValueNumerical) {
                if (!configFieldMaxCharacters.error) {
                    let valueMinMax = this.displayIncreasingNumbers(max_characters);
                    configFieldFromRange.maxlength = Number(max_characters) + 1;
                    configFieldToRange.maxlength = Number(max_characters) + 1;
                    configFieldFromRange.min = max_characters < 10 ? `-${valueMinMax}` : '-2147483648';
                    configFieldFromRange.max = max_characters < 10 ? `${valueMinMax}` : '2147483647';
                    configFieldToRange.min = max_characters < 10 ? `-${valueMinMax}` : '-2147483648';
                    configFieldToRange.max = max_characters < 10 ? `${valueMinMax}` : '2147483647';
                }
            } else {
                configFieldFromRange.maxlength = 255;
                configFieldToRange.maxlength = 255;
                if (max_characters && configFieldMaximumNumber.valueSync && Number(max_characters) < Number(configFieldMaximumNumber.valueSync)) {
                    characterCheck = false;
                    configFieldMaximumNumber.error = true;
                    configFieldMaximumNumber.errorCustomMess = `${configFieldMaximumNumber.errorField}が${configFieldMaxCharacters.errorField}を超えています。`;
                } else {
                    configFieldMaximumNumber.error = false;
                }
            }

            if (this.isActiveKeywordUpload) {
                configFieldKeywordUpload.length = max_characters;
            }
            return characterCheck;
        },

        displayIncreasingNumbers(input) {
            const num = parseInt(input, 10);
            return '9'.repeat(num);
        },

        onHandleRequired(isRequired) {
            let { configFieldLabelUncheck } = this.configFormInput;
            if (isRequired) {
                configFieldLabelUncheck.typesValidate = [];
            } else {
                configFieldLabelUncheck.typesValidate = ['required', 'max20'];
            }
        },

        handleOpenMultiselect(typeOpen) {
            switch (typeOpen) {
                case 1:
                    this.LIST_BLOCK_SEARCH_ADDRESS = this.listBlockCreated?.filter((item) =>
                        [ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE, ALL_BLOCK_TYPE.BLOCK_INPUT].includes(item.block_type)
                    );
                    break;
                case 2:
                case 3:
                    this.LIST_BLOCK_SEARCH_ADDRESS = this.listBlockCreated?.filter((item) => [ALL_BLOCK_TYPE.BLOCK_INPUT].includes(item.block_type));
                    break;
            }
        },

        onHandleValueDefaultFeaturePostCode() {
            if (!this.listBlockCreated?.length || !this.blockForm.block_type !== ALL_BLOCK_TYPE.BLOCK_POST_CODE) return;
            if (!this.blockForm.block_post_code.prefecture_insertion) {
                this.blockForm.block_post_code.prefecture_insertion =
                    this.listBlockCreated.fillter((item) =>
                        [ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE, ALL_BLOCK_TYPE.BLOCK_INPUT].includes(item.block_type)
                    )[0] ?? null;
            }
            if (!this.blockForm.block_post_code.city_insertion) {
                this.blockForm.block_post_code.city_insertion =
                    this.listBlockCreated.fillter((item) => item.block_type === ALL_BLOCK_TYPE.BLOCK_INPUT)[0] ?? null;
            }
            if (!this.blockForm.block_post_code.town_area_name_insertion) {
                this.blockForm.block_post_code.town_area_name_insertion =
                    this.listBlockCreated.fillter((item) => item.block_type === ALL_BLOCK_TYPE.BLOCK_INPUT)[0] ?? null;
            }
        },

        onHandleSetCellColor() {
            if (this.blockForm.cell_background_color.is_bg_question_default) {
                this.blockForm.cell_background_color.bg_question = this.bgrDefault.bg_question;
            }
            if (this.blockForm.cell_background_color.is_bg_answer_default) {
                this.blockForm.cell_background_color.bg_answer = this.bgrDefault.bg_answer;
            }
        },

        onHandleShowNoteFileRead() {
            return this.configKeywordUploadFile.allowedExtension?.filter((item) => item !== 'plain').join(', ');
        },

        onHandleSetChoicePlacement() {
            if (!this.blockForm.choice_placement_specification_question) {
                this.blockForm.choice_placement_specification_question = onHandleGetValueTextAlign(
                    this.inforSettingDesign.table_settings.question_text_alignment.horizontal
                );
            }
            if (!this.blockForm.choice_placement_specification_answer) {
                this.blockForm.choice_placement_specification_answer = onHandleGetValueTextAlign(
                    this.inforSettingDesign.table_settings.answer_text_alignment.horizontal
                );
            }
        },

        onHandleRenderTextPlacement(alignList, valueAlignDesign) {
            return alignList.find((item) => item.value === valueAlignDesign).label ?? '';
        },

        onHandleRenderTextLayout(typeLayout, layoutDesign) {
            let valueLayout = '';
            switch (layoutDesign) {
                case 'horizontal':
                    valueLayout = 'row';
                    break;
                case 'vertical':
                    valueLayout = 'cols';
                    break;
            }
            return typeLayout.find((item) => item.value === valueLayout)?.label ?? '';
        }
    },
    created() {
        if (this.blockForm?.block_input?.age_condition) {
            const currentOp = this.blockForm.block_input.age_condition.operator;
            if (currentOp) {
                const found = OPTION_AGE_CONDITION.find(
                    (o) => o.id === currentOp?.id || o.value === currentOp?.value || o.id === currentOp || o.value === currentOp
                );
                if (found) {
                    this.blockForm.block_input.age_condition.operator = found;
                }
            }
        } else if (this.blockForm?.block_input) {
            this.$set(this.blockForm.block_input, 'age_condition', { operator: null, value: '' });
        }
        if (this.configFormInput?.configFieldAgeConditionValue) {
            this.configFormInput.configFieldAgeConditionValue.valueSync = this.blockForm?.block_input?.age_condition?.value ?? '';
        }
    },
    mounted() {},
    watch: {
        actionTimeAddBlock: {
            handler: function () {
                this.onHandleChangeTypeCanlendar(this.blockForm?.block_date?.format_year?.type_calendar);
                this.onHandleValueDefaultFeaturePostCode();
                this.onHandleSetCellColor();
                this.onHandleSetMaxcharacters();
                this.onHandleSetChoicePlacement();
                this.handleChangeTypeYear(this.blockForm?.block_date?.format_year?.type, 'watch');
                this.isSettingStep1 = true;
            },
            immediate: true
        },

        formBlock: {
            handler: function (newVal) {
                this.blockForm = newVal;
                if (this.blockForm?.block_input?.age_condition) {
                    const currentOp = this.blockForm.block_input.age_condition.operator;
                    if (currentOp) {
                        const found = OPTION_AGE_CONDITION.find(
                            (o) => o.id === currentOp?.id || o.value === currentOp?.value || o.id === currentOp || o.value === currentOp
                        );
                        if (found) {
                            this.blockForm.block_input.age_condition.operator = found;
                        }
                    }
                }
                if (this.configFormInput?.configFieldAgeConditionValue) {
                    this.configFormInput.configFieldAgeConditionValue.valueSync = this.blockForm?.block_input?.age_condition?.value ?? '';
                }
                this.onHandleSetCellColor();
                this.onHandleSetMaxcharacters();
                this.onHandleSetChoicePlacement();
            },
            deep: true
        },

        blockForm: {
            handler: function (newVal) {
                this.$emit('update:formBlock', newVal);
            },
            deep: true
        },

        listTypeInput: {
            handler: function (newType) {
                this.listOptionText = newType;
            },
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped>
.border-top-1-color {
    border-top: 1px solid #0000001a;
}
.return__page--design {
    border: #ff5800 1px solid;
    padding: 2px 10px;
    color: #ff5800;
    margin: 10px 0 0 0;
    font-size: 13px;
    border-radius: 5px;
    text-align-last: center;
    line-height: 35px;
    text-decoration: none;
    font-weight: 600;
    &:hover {
        opacity: 0.6;
    }
}
</style>
